import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const FirstChronicles : Scripture = {
  "version": VERSIONS.KJV,
  "book": BOOKS.FIRST_CHRONICLES,
  "chapters": [
    {
      "chapter": "1",
      "verses": [
        { "verse": "1", "text": "Adam, Sheth, Enosh," },
        { "verse": "2", "text": "Kenan, Mahalaleel, Jered," },
        { "verse": "3", "text": "Henoch, Methuselah, Lamech," },
        { "verse": "4", "text": "Noah, Shem, Ham, and Japheth." },
        {
          "verse": "5",
          "text": "The sons of Japheth; Gomer, and Magog, and Madai, and Javan, and Tubal, and Meshech, and Tiras."
        },
        {
          "verse": "6",
          "text": "And the sons of Gomer; Ashchenaz, and Riphath, and Togarmah."
        },
        {
          "verse": "7",
          "text": "And the sons of Javan; Elishah, and Tarshish, Kittim, and Dodanim."
        },
        {
          "verse": "8",
          "text": "The sons of Ham; Cush, and Mizraim, Put, and Canaan."
        },
        {
          "verse": "9",
          "text": "And the sons of Cush; Seba, and Havilah, and Sabta, and Raamah, and Sabtecha. And the sons of Raamah; Sheba, and Dedan."
        },
        {
          "verse": "10",
          "text": "And Cush begat Nimrod: he began to be mighty upon the earth."
        },
        {
          "verse": "11",
          "text": "And Mizraim begat Ludim, and Anamim, and Lehabim, and Naphtuhim,"
        },
        {
          "verse": "12",
          "text": "And Pathrusim, and Casluhim, (of whom came the Philistines,) and Caphthorim."
        },
        {
          "verse": "13",
          "text": "And Canaan begat Zidon his firstborn, and Heth,"
        },
        {
          "verse": "14",
          "text": "The Jebusite also, and the Amorite, and the Girgashite,"
        },
        {
          "verse": "15",
          "text": "And the Hivite, and the Arkite, and the Sinite,"
        },
        {
          "verse": "16",
          "text": "And the Arvadite, and the Zemarite, and the Hamathite."
        },
        {
          "verse": "17",
          "text": "The sons of Shem; Elam, and Asshur, and Arphaxad, and Lud, and Aram, and Uz, and Hul, and Gether, and Meshech."
        },
        {
          "verse": "18",
          "text": "And Arphaxad begat Shelah, and Shelah begat Eber."
        },
        {
          "verse": "19",
          "text": "And unto Eber were born two sons: the name of the one was Peleg; because in his days the earth was divided: and his brother\u2019s name was Joktan."
        },
        {
          "verse": "20",
          "text": "And Joktan begat Almodad, and Sheleph, and Hazarmaveth, and Jerah,"
        },
        { "verse": "21", "text": "Hadoram also, and Uzal, and Diklah," },
        { "verse": "22", "text": "And Ebal, and Abimael, and Sheba," },
        {
          "verse": "23",
          "text": "And Ophir, and Havilah, and Jobab. All these were the sons of Joktan."
        },
        { "verse": "24", "text": "Shem, Arphaxad, Shelah," },
        { "verse": "25", "text": "Eber, Peleg, Reu," },
        { "verse": "26", "text": "Serug, Nahor, Terah," },
        { "verse": "27", "text": "Abram; the same is Abraham." },
        { "verse": "28", "text": "The sons of Abraham; Isaac, and Ishmael." },
        {
          "verse": "29",
          "text": "These are their generations: The firstborn of Ishmael, Nebaioth; then Kedar, and Adbeel, and Mibsam,"
        },
        { "verse": "30", "text": "Mishma, and Dumah, Massa, Hadad, and Tema," },
        {
          "verse": "31",
          "text": "Jetur, Naphish, and Kedemah. These are the sons of Ishmael."
        },
        {
          "verse": "32",
          "text": "Now the sons of Keturah, Abraham\u2019s concubine: she bare Zimran, and Jokshan, and Medan, and Midian, and Ishbak, and Shuah. And the sons of Jokshan; Sheba, and Dedan."
        },
        {
          "verse": "33",
          "text": "And the sons of Midian; Ephah, and Epher, and Henoch, and Abida, and Eldaah. All these are the sons of Keturah."
        },
        {
          "verse": "34",
          "text": "And Abraham begat Isaac. The sons of Isaac; Esau and Israel."
        },
        {
          "verse": "35",
          "text": "The sons of Esau; Eliphaz, Reuel, and Jeush, and Jaalam, and Korah."
        },
        {
          "verse": "36",
          "text": "The sons of Eliphaz; Teman, and Omar, Zephi, and Gatam, Kenaz, and Timna, and Amalek."
        },
        {
          "verse": "37",
          "text": "The sons of Reuel; Nahath, Zerah, Shammah, and Mizzah."
        },
        {
          "verse": "38",
          "text": "And the sons of Seir; Lotan, and Shobal, and Zibeon, and Anah, and Dishon, and Ezar, and Dishan."
        },
        {
          "verse": "39",
          "text": "And the sons of Lotan; Hori, and Homam: and Timna was Lotan\u2019s sister."
        },
        {
          "verse": "40",
          "text": "The sons of Shobal; Alian, and Manahath, and Ebal, Shephi, and Onam. And the sons of Zibeon; Aiah, and Anah."
        },
        {
          "verse": "41",
          "text": "The sons of Anah; Dishon. And the sons of Dishon; Amram, and Eshban, and Ithran, and Cheran."
        },
        {
          "verse": "42",
          "text": "The sons of Ezer; Bilhan, and Zavan, and Jakan. The sons of Dishan; Uz, and Aran."
        },
        {
          "verse": "43",
          "text": "Now these are the kings that reigned in the land of Edom before any king reigned over the children of Israel; Bela the son of Beor: and the name of his city was Dinhabah."
        },
        {
          "verse": "44",
          "text": "And when Bela was dead, Jobab the son of Zerah of Bozrah reigned in his stead."
        },
        {
          "verse": "45",
          "text": "And when Jobab was dead, Husham of the land of the Temanites reigned in his stead."
        },
        {
          "verse": "46",
          "text": "And when Husham was dead, Hadad the son of Bedad, which smote Midian in the field of Moab, reigned in his stead: and the name of his city was Avith."
        },
        {
          "verse": "47",
          "text": "And when Hadad was dead, Samlah of Masrekah reigned in his stead."
        },
        {
          "verse": "48",
          "text": "And when Samlah was dead, Shaul of Rehoboth by the river reigned in his stead."
        },
        {
          "verse": "49",
          "text": "And when Shaul was dead, Baalhanan the son of Achbor reigned in his stead."
        },
        {
          "verse": "50",
          "text": "And when Baalhanan was dead, Hadad reigned in his stead: and the name of his city was Pai; and his wife\u2019s name was Mehetabel, the daughter of Matred, the daughter of Mezahab."
        },
        {
          "verse": "51",
          "text": "Hadad died also. And the dukes of Edom were; duke Timnah, duke Aliah, duke Jetheth,"
        },
        { "verse": "52", "text": "Duke Aholibamah, duke Elah, duke Pinon," },
        { "verse": "53", "text": "Duke Kenaz, duke Teman, duke Mibzar," },
        {
          "verse": "54",
          "text": "Duke Magdiel, duke Iram. These are the dukes of Edom."
        }
      ]
    },
    {
      "chapter": "2",
      "verses": [
        {
          "verse": "1",
          "text": "These are the sons of Israel; Reuben, Simeon, Levi, and Judah, Issachar, and Zebulun,"
        },
        {
          "verse": "2",
          "text": "Dan, Joseph, and Benjamin, Naphtali, Gad, and Asher."
        },
        {
          "verse": "3",
          "text": "The sons of Judah; Er, and Onan, and Shelah: which three were born unto him of the daughter of Shua the Canaanitess. And Er, the firstborn of Judah, was evil in the sight of the LORD; and he slew him."
        },
        {
          "verse": "4",
          "text": "And Tamar his daughter in law bore him Pharez and Zerah. All the sons of Judah were five."
        },
        { "verse": "5", "text": "The sons of Pharez; Hezron, and Hamul." },
        {
          "verse": "6",
          "text": "And the sons of Zerah; Zimri, and Ethan, and Heman, and Calcol, and Dara: five of them in all."
        },
        {
          "verse": "7",
          "text": "And the sons of Carmi; Achar, the troubler of Israel, who transgressed in the thing accursed."
        },
        { "verse": "8", "text": "And the sons of Ethan; Azariah." },
        {
          "verse": "9",
          "text": "The sons also of Hezron, that were born unto him; Jerahmeel, and Ram, and Chelubai."
        },
        {
          "verse": "10",
          "text": "And Ram begat Amminadab; and Amminadab begat Nahshon, prince of the children of Judah;"
        },
        {
          "verse": "11",
          "text": "And Nahshon begat Salma, and Salma begat Boaz,"
        },
        { "verse": "12", "text": "And Boaz begat Obed, and Obed begat Jesse," },
        {
          "verse": "13",
          "text": "And Jesse begat his firstborn Eliab, and Abinadab the second, and Shimma the third,"
        },
        { "verse": "14", "text": "Nethaneel the fourth, Raddai the fifth," },
        { "verse": "15", "text": "Ozem the sixth, David the seventh:" },
        {
          "verse": "16",
          "text": "Whose sisters were Zeruiah, and Abigail. And the sons of Zeruiah; Abishai, and Joab, and Asahel, three."
        },
        {
          "verse": "17",
          "text": "And Abigail bare Amasa: and the father of Amasa was Jether the Ishmeelite."
        },
        {
          "verse": "18",
          "text": "And Caleb the son of Hezron begat children of Azubah his wife, and of Jerioth: her sons are these; Jesher, and Shobab, and Ardon."
        },
        {
          "verse": "19",
          "text": "And when Azubah was dead, Caleb took unto him Ephrath, which bare him Hur."
        },
        { "verse": "20", "text": "And Hur begat Uri, and Uri begat Bezaleel." },
        {
          "verse": "21",
          "text": "And afterward Hezron went in to the daughter of Machir the father of Gilead, whom he married when he was threescore years old; and she bare him Segub."
        },
        {
          "verse": "22",
          "text": "And Segub begat Jair, who had three and twenty cities in the land of Gilead."
        },
        {
          "verse": "23",
          "text": "And he took Geshur, and Aram, with the towns of Jair, from them, with Kenath, and the towns thereof, even threescore cities. All these belonged to the sons of Machir the father of Gilead."
        },
        {
          "verse": "24",
          "text": "And after that Hezron was dead in Calebephratah, then Abiah Hezron\u2019s wife bare him Ashur the father of Tekoa."
        },
        {
          "verse": "25",
          "text": "And the sons of Jerahmeel the firstborn of Hezron were, Ram the firstborn, and Bunah, and Oren, and Ozem, and Ahijah."
        },
        {
          "verse": "26",
          "text": "Jerahmeel had also another wife, whose name was Atarah; she was the mother of Onam."
        },
        {
          "verse": "27",
          "text": "And the sons of Ram the firstborn of Jerahmeel were, Maaz, and Jamin, and Eker."
        },
        {
          "verse": "28",
          "text": "And the sons of Onam were, Shammai, and Jada. And the sons of Shammai; Nadab, and Abishur."
        },
        {
          "verse": "29",
          "text": "And the name of the wife of Abishur was Abihail, and she bare him Ahban, and Molid."
        },
        {
          "verse": "30",
          "text": "And the sons of Nadab; Seled, and Appaim: but Seled died without children."
        },
        {
          "verse": "31",
          "text": "And the sons of Appaim; Ishi. And the sons of Ishi; Sheshan. And the children of Sheshan; Ahlai."
        },
        {
          "verse": "32",
          "text": "And the sons of Jada the brother of Shammai; Jether, and Jonathan: and Jether died without children."
        },
        {
          "verse": "33",
          "text": "And the sons of Jonathan; Peleth, and Zaza. These were the sons of Jerahmeel."
        },
        {
          "verse": "34",
          "text": "Now Sheshan had no sons, but daughters. And Sheshan had a servant, an Egyptian, whose name was Jarha."
        },
        {
          "verse": "35",
          "text": "And Sheshan gave his daughter to Jarha his servant to wife; and she bare him Attai."
        },
        {
          "verse": "36",
          "text": "And Attai begat Nathan, and Nathan begat Zabad,"
        },
        {
          "verse": "37",
          "text": "And Zabad begat Ephlal, and Ephlal begat Obed,"
        },
        {
          "verse": "38",
          "text": "And Obed begat Jehu, and Jehu begat Azariah,"
        },
        {
          "verse": "39",
          "text": "And Azariah begat Helez, and Helez begat Eleasah,"
        },
        {
          "verse": "40",
          "text": "And Eleasah begat Sisamai, and Sisamai begat Shallum,"
        },
        {
          "verse": "41",
          "text": "And Shallum begat Jekamiah, and Jekamiah begat Elishama."
        },
        {
          "verse": "42",
          "text": "Now the sons of Caleb the brother of Jerahmeel were, Mesha his firstborn, which was the father of Ziph; and the sons of Mareshah the father of Hebron."
        },
        {
          "verse": "43",
          "text": "And the sons of Hebron; Korah, and Tappuah, and Rekem, and Shema."
        },
        {
          "verse": "44",
          "text": "And Shema begat Raham, the father of Jorkoam: and Rekem begat Shammai."
        },
        {
          "verse": "45",
          "text": "And the son of Shammai was Maon: and Maon was the father of Bethzur."
        },
        {
          "verse": "46",
          "text": "And Ephah, Caleb\u2019s concubine, bare Haran, and Moza, and Gazez: and Haran begat Gazez."
        },
        {
          "verse": "47",
          "text": "And the sons of Jahdai; Regem, and Jotham, and Gesham, and Pelet, and Ephah, and Shaaph."
        },
        {
          "verse": "48",
          "text": "Maachah, Caleb\u2019s concubine, bare Sheber, and Tirhanah."
        },
        {
          "verse": "49",
          "text": "She bare also Shaaph the father of Madmannah, Sheva the father of Machbenah, and the father of Gibea: and the daughter of Caleb was Achsa."
        },
        {
          "verse": "50",
          "text": "These were the sons of Caleb the son of Hur, the firstborn of Ephratah; Shobal the father of Kirjathjearim,"
        },
        {
          "verse": "51",
          "text": "Salma the father of Bethlehem, Hareph the father of Bethgader."
        },
        {
          "verse": "52",
          "text": "And Shobal the father of Kirjathjearim had sons; Haroeh, and half of the Manahethites."
        },
        {
          "verse": "53",
          "text": "And the families of Kirjathjearim; the Ithrites, and the Puhites, and the Shumathites, and the Mishraites; of them came the Zareathites, and the Eshtaulites."
        },
        {
          "verse": "54",
          "text": "The sons of Salma; Bethlehem, and the Netophathites, Ataroth, the house of Joab, and half of the Manahethites, the Zorites."
        },
        {
          "verse": "55",
          "text": "And the families of the scribes which dwelt at Jabez; the Tirathites, the Shimeathites, and Suchathites. These are the Kenites that came of Hemath, the father of the house of Rechab."
        }
      ]
    },
    {
      "chapter": "3",
      "verses": [
        {
          "verse": "1",
          "text": "Now these were the sons of David, which were born unto him in Hebron; the firstborn Amnon, of Ahinoam the Jezreelitess; the second Daniel, of Abigail the Carmelitess:"
        },
        {
          "verse": "2",
          "text": "The third, Absalom the son of Maachah the daughter of Talmai king of Geshur: the fourth, Adonijah the son of Haggith:"
        },
        {
          "verse": "3",
          "text": "The fifth, Shephatiah of Abital: the sixth, Ithream by Eglah his wife."
        },
        {
          "verse": "4",
          "text": "These six were born unto him in Hebron; and there he reigned seven years and six months: and in Jerusalem he reigned thirty and three years."
        },
        {
          "verse": "5",
          "text": "And these were born unto him in Jerusalem; Shimea, and Shobab, and Nathan, and Solomon, four, of Bathshua the daughter of Ammiel:"
        },
        { "verse": "6", "text": "Ibhar also, and Elishama, and Eliphelet," },
        { "verse": "7", "text": "And Nogah, and Nepheg, and Japhia," },
        {
          "verse": "8",
          "text": "And Elishama, and Eliada, and Eliphelet, nine."
        },
        {
          "verse": "9",
          "text": "These were all the sons of David, beside the sons of the concubines, and Tamar their sister."
        },
        {
          "verse": "10",
          "text": "And Solomon\u2019s son was Rehoboam, Abia his son, Asa his son, Jehoshaphat his son,"
        },
        {
          "verse": "11",
          "text": "Joram his son, Ahaziah his son, Joash his son,"
        },
        {
          "verse": "12",
          "text": "Amaziah his son, Azariah his son, Jotham his son,"
        },
        {
          "verse": "13",
          "text": "Ahaz his son, Hezekiah his son, Manasseh his son,"
        },
        { "verse": "14", "text": "Amon his son, Josiah his son." },
        {
          "verse": "15",
          "text": "And the sons of Josiah were, the firstborn Johanan, the second Jehoiakim, the third Zedekiah, the fourth Shallum."
        },
        {
          "verse": "16",
          "text": "And the sons of Jehoiakim: Jeconiah his son, Zedekiah his son."
        },
        {
          "verse": "17",
          "text": "And the sons of Jeconiah; Assir, Salathiel his son,"
        },
        {
          "verse": "18",
          "text": "Malchiram also, and Pedaiah, and Shenazar, Jecamiah, Hoshama, and Nedabiah."
        },
        {
          "verse": "19",
          "text": "And the sons of Pedaiah were, Zerubbabel, and Shimei: and the sons of Zerubbabel; Meshullam, and Hananiah, and Shelomith their sister:"
        },
        {
          "verse": "20",
          "text": "And Hashubah, and Ohel, and Berechiah, and Hasadiah, Jushabhesed, five."
        },
        {
          "verse": "21",
          "text": "And the sons of Hananiah; Pelatiah, and Jesaiah: the sons of Rephaiah, the sons of Arnan, the sons of Obadiah, the sons of Shechaniah."
        },
        {
          "verse": "22",
          "text": "And the sons of Shechaniah; Shemaiah: and the sons of Shemaiah; Hattush, and Igeal, and Bariah, and Neariah, and Shaphat, six."
        },
        {
          "verse": "23",
          "text": "And the sons of Neariah; Elioenai, and Hezekiah, and Azrikam, three."
        },
        {
          "verse": "24",
          "text": "And the sons of Elioenai were, Hodaiah, and Eliashib, and Pelaiah, and Akkub, and Johanan, and Dalaiah, and Anani, seven."
        }
      ]
    },
    {
      "chapter": "4",
      "verses": [
        {
          "verse": "1",
          "text": "The sons of Judah; Pharez, Hezron, and Carmi, and Hur, and Shobal."
        },
        {
          "verse": "2",
          "text": "And Reaiah the son of Shobal begat Jahath; and Jahath begat Ahumai, and Lahad. These are the families of the Zorathites."
        },
        {
          "verse": "3",
          "text": "And these were of the father of Etam; Jezreel, and Ishma, and Idbash: and the name of their sister was Hazelelponi:"
        },
        {
          "verse": "4",
          "text": "And Penuel the father of Gedor, and Ezer the father of Hushah. These are the sons of Hur, the firstborn of Ephratah, the father of Bethlehem."
        },
        {
          "verse": "5",
          "text": "And Ashur the father of Tekoa had two wives, Helah and Naarah."
        },
        {
          "verse": "6",
          "text": "And Naarah bare him Ahuzam, and Hepher, and Temeni, and Haahashtari. These were the sons of Naarah."
        },
        {
          "verse": "7",
          "text": "And the sons of Helah were, Zereth, and Jezoar, and Ethnan."
        },
        {
          "verse": "8",
          "text": "And Coz begat Anub, and Zobebah, and the families of Aharhel the son of Harum."
        },
        {
          "verse": "9",
          "text": "And Jabez was more honourable than his brethren: and his mother called his name Jabez, saying, Because I bare him with sorrow."
        },
        {
          "verse": "10",
          "text": "And Jabez called on the God of Israel, saying, Oh that thou wouldest bless me indeed, and enlarge my coast, and that thine hand might be with me, and that thou wouldest keep me from evil, that it may not grieve me! And God granted him that which he requested."
        },
        {
          "verse": "11",
          "text": "And Chelub the brother of Shuah begat Mehir, which was the father of Eshton."
        },
        {
          "verse": "12",
          "text": "And Eshton begat Bethrapha, and Paseah, and Tehinnah the father of Irnahash. These are the men of Rechah."
        },
        {
          "verse": "13",
          "text": "And the sons of Kenaz; Othniel, and Seraiah: and the sons of Othniel; Hathath."
        },
        {
          "verse": "14",
          "text": "And Meonothai begat Ophrah: and Seraiah begat Joab, the father of the valley of Charashim; for they were craftsmen."
        },
        {
          "verse": "15",
          "text": "And the sons of Caleb the son of Jephunneh; Iru, Elah, and Naam: and the sons of Elah, even Kenaz."
        },
        {
          "verse": "16",
          "text": "And the sons of Jehaleleel; Ziph, and Ziphah, Tiria, and Asareel."
        },
        {
          "verse": "17",
          "text": "And the sons of Ezra were, Jether, and Mered, and Epher, and Jalon: and she bare Miriam, and Shammai, and Ishbah the father of Eshtemoa."
        },
        {
          "verse": "18",
          "text": "And his wife Jehudijah bare Jered the father of Gedor, and Heber the father of Socho, and Jekuthiel the father of Zanoah. And these are the sons of Bithiah the daughter of Pharaoh, which Mered took."
        },
        {
          "verse": "19",
          "text": "And the sons of his wife Hodiah the sister of Naham, the father of Keilah the Garmite, and Eshtemoa the Maachathite."
        },
        {
          "verse": "20",
          "text": "And the sons of Shimon were, Amnon, and Rinnah, Benhanan, and Tilon. And the sons of Ishi were, Zoheth, and Benzoheth."
        },
        {
          "verse": "21",
          "text": "The sons of Shelah the son of Judah were, Er the father of Lecah, and Laadah the father of Mareshah, and the families of the house of them that wrought fine linen, of the house of Ashbea,"
        },
        {
          "verse": "22",
          "text": "And Jokim, and the men of Chozeba, and Joash, and Saraph, who had the dominion in Moab, and Jashubilehem. And these are ancient things."
        },
        {
          "verse": "23",
          "text": "These were the potters, and those that dwelt among plants and hedges: there they dwelt with the king for his work."
        },
        {
          "verse": "24",
          "text": "The sons of Simeon were, Nemuel, and Jamin, Jarib, Zerah, and Shaul:"
        },
        {
          "verse": "25",
          "text": "Shallum his son, Mibsam his son, Mishma his son."
        },
        {
          "verse": "26",
          "text": "And the sons of Mishma; Hamuel his son, Zacchur his son, Shimei his son."
        },
        {
          "verse": "27",
          "text": "And Shimei had sixteen sons and six daughters; but his brethren had not many children, neither did all their family multiply, like to the children of Judah."
        },
        {
          "verse": "28",
          "text": "And they dwelt at Beersheba, and Moladah, and Hazarshual,"
        },
        { "verse": "29", "text": "And at Bilhah, and at Ezem, and at Tolad," },
        {
          "verse": "30",
          "text": "And at Bethuel, and at Hormah, and at Ziklag,"
        },
        {
          "verse": "31",
          "text": "And at Bethmarcaboth, and Hazarsusim, and at Bethbirei, and at Shaaraim. These were their cities unto the reign of David."
        },
        {
          "verse": "32",
          "text": "And their villages were, Etam, and Ain, Rimmon, and Tochen, and Ashan, five cities:"
        },
        {
          "verse": "33",
          "text": "And all their villages that were round about the same cities, unto Baal. These were their habitations, and their genealogy."
        },
        {
          "verse": "34",
          "text": "And Meshobab, and Jamlech, and Joshah, the son of Amaziah,"
        },
        {
          "verse": "35",
          "text": "And Joel, and Jehu the son of Josibiah, the son of Seraiah, the son of Asiel,"
        },
        {
          "verse": "36",
          "text": "And Elioenai, and Jaakobah, and Jeshohaiah, and Asaiah, and Adiel, and Jesimiel, and Benaiah,"
        },
        {
          "verse": "37",
          "text": "And Ziza the son of Shiphi, the son of Allon, the son of Jedaiah, the son of Shimri, the son of Shemaiah;"
        },
        {
          "verse": "38",
          "text": "These mentioned by their names were princes in their families: and the house of their fathers increased greatly."
        },
        {
          "verse": "39",
          "text": "And they went to the entrance of Gedor, even unto the east side of the valley, to seek pasture for their flocks."
        },
        {
          "verse": "40",
          "text": "And they found fat pasture and good, and the land was wide, and quiet, and peaceable; for they of Ham had dwelt there of old."
        },
        {
          "verse": "41",
          "text": "And these written by name came in the days of Hezekiah king of Judah, and smote their tents, and the habitations that were found there, and destroyed them utterly unto this day, and dwelt in their rooms: because there was pasture there for their flocks."
        },
        {
          "verse": "42",
          "text": "And some of them, even of the sons of Simeon, five hundred men, went to mount Seir, having for their captains Pelatiah, and Neariah, and Rephaiah, and Uzziel, the sons of Ishi."
        },
        {
          "verse": "43",
          "text": "And they smote the rest of the Amalekites that were escaped, and dwelt there unto this day."
        }
      ]
    },
    {
      "chapter": "5",
      "verses": [
        {
          "verse": "1",
          "text": "Now the sons of Reuben the firstborn of Israel, (for he was the firstborn; but, forasmuch as he defiled his father\u2019s bed, his birthright was given unto the sons of Joseph the son of Israel: and the genealogy is not to be reckoned after the birthright."
        },
        {
          "verse": "2",
          "text": "For Judah prevailed above his brethren, and of him came the chief ruler; but the birthright was Joseph\u2019s:)"
        },
        {
          "verse": "3",
          "text": "The sons, I say, of Reuben the firstborn of Israel were, Hanoch, and Pallu, Hezron, and Carmi."
        },
        {
          "verse": "4",
          "text": "The sons of Joel; Shemaiah his son, Gog his son, Shimei his son,"
        },
        { "verse": "5", "text": "Micah his son, Reaia his son, Baal his son," },
        {
          "verse": "6",
          "text": "Beerah his son, whom Tilgathpilneser king of Assyria carried away captive: he was prince of the Reubenites."
        },
        {
          "verse": "7",
          "text": "And his brethren by their families, when the genealogy of their generations was reckoned, were the chief, Jeiel, and Zechariah,"
        },
        {
          "verse": "8",
          "text": "And Bela the son of Azaz, the son of Shema, the son of Joel, who dwelt in Aroer, even unto Nebo and Baalmeon:"
        },
        {
          "verse": "9",
          "text": "And eastward he inhabited unto the entering in of the wilderness from the river Euphrates: because their cattle were multiplied in the land of Gilead."
        },
        {
          "verse": "10",
          "text": "And in the days of Saul they made war with the Hagarites, who fell by their hand: and they dwelt in their tents throughout all the east land of Gilead."
        },
        {
          "verse": "11",
          "text": "And the children of Gad dwelt over against them, in the land of Bashan unto Salcah:"
        },
        {
          "verse": "12",
          "text": "Joel the chief, and Shapham the next, and Jaanai, and Shaphat in Bashan."
        },
        {
          "verse": "13",
          "text": "And their brethren of the house of their fathers were, Michael, and Meshullam, and Sheba, and Jorai, and Jachan, and Zia, and Heber, seven."
        },
        {
          "verse": "14",
          "text": "These are the children of Abihail the son of Huri, the son of Jaroah, the son of Gilead, the son of Michael, the son of Jeshishai, the son of Jahdo, the son of Buz;"
        },
        {
          "verse": "15",
          "text": "Ahi the son of Abdiel, the son of Guni, chief of the house of their fathers."
        },
        {
          "verse": "16",
          "text": "And they dwelt in Gilead in Bashan, and in her towns, and in all the suburbs of Sharon, upon their borders."
        },
        {
          "verse": "17",
          "text": "All these were reckoned by genealogies in the days of Jotham king of Judah, and in the days of Jeroboam king of Israel."
        },
        {
          "verse": "18",
          "text": "The sons of Reuben, and the Gadites, and half the tribe of Manasseh, of valiant men, men able to bear buckler and sword, and to shoot with bow, and skilful in war, were four and forty thousand seven hundred and threescore, that went out to the war."
        },
        {
          "verse": "19",
          "text": "And they made war with the Hagarites, with Jetur, and Nephish, and Nodab."
        },
        {
          "verse": "20",
          "text": "And they were helped against them, and the Hagarites were delivered into their hand, and all that were with them: for they cried to God in the battle, and he was intreated of them; because they put their trust in him."
        },
        {
          "verse": "21",
          "text": "And they took away their cattle; of their camels fifty thousand, and of sheep two hundred and fifty thousand, and of asses two thousand, and of men an hundred thousand."
        },
        {
          "verse": "22",
          "text": "For there fell down many slain, because the war was of God. And they dwelt in their steads until the captivity."
        },
        {
          "verse": "23",
          "text": "And the children of the half tribe of Manasseh dwelt in the land: they increased from Bashan unto Baalhermon and Senir, and unto mount Hermon."
        },
        {
          "verse": "24",
          "text": "And these were the heads of the house of their fathers, even Epher, and Ishi, and Eliel, and Azriel, and Jeremiah, and Hodaviah, and Jahdiel, mighty men of valour, famous men, and heads of the house of their fathers."
        },
        {
          "verse": "25",
          "text": "And they transgressed against the God of their fathers, and went a whoring after the gods of the people of the land, whom God destroyed before them."
        },
        {
          "verse": "26",
          "text": "And the God of Israel stirred up the spirit of Pul king of Assyria, and the spirit of Tilgathpilneser king of Assyria, and he carried them away, even the Reubenites, and the Gadites, and the half tribe of Manasseh, and brought them unto Halah, and Habor, and Hara, and to the river Gozan, unto this day."
        }
      ]
    },
    {
      "chapter": "6",
      "verses": [
        {
          "verse": "1",
          "text": "The sons of Levi; Gershon, Kohath, and Merari."
        },
        {
          "verse": "2",
          "text": "And the sons of Kohath; Amram, Izhar, and Hebron, and Uzziel."
        },
        {
          "verse": "3",
          "text": "And the children of Amram; Aaron, and Moses, and Miriam. The sons also of Aaron; Nadab, and Abihu, Eleazar, and Ithamar."
        },
        {
          "verse": "4",
          "text": "Eleazar begat Phinehas, Phinehas begat Abishua,"
        },
        {
          "verse": "5",
          "text": "And Abishua begat Bukki, and Bukki begat Uzzi,"
        },
        {
          "verse": "6",
          "text": "And Uzzi begat Zerahiah, and Zerahiah begat Meraioth,"
        },
        {
          "verse": "7",
          "text": "Meraioth begat Amariah, and Amariah begat Ahitub,"
        },
        {
          "verse": "8",
          "text": "And Ahitub begat Zadok, and Zadok begat Ahimaaz,"
        },
        {
          "verse": "9",
          "text": "And Ahimaaz begat Azariah, and Azariah begat Johanan,"
        },
        {
          "verse": "10",
          "text": "And Johanan begat Azariah, (he it is that executed the priest\u2019s office in the temple that Solomon built in Jerusalem:)"
        },
        {
          "verse": "11",
          "text": "And Azariah begat Amariah, and Amariah begat Ahitub,"
        },
        {
          "verse": "12",
          "text": "And Ahitub begat Zadok, and Zadok begat Shallum,"
        },
        {
          "verse": "13",
          "text": "And Shallum begat Hilkiah, and Hilkiah begat Azariah,"
        },
        {
          "verse": "14",
          "text": "And Azariah begat Seraiah, and Seraiah begat Jehozadak,"
        },
        {
          "verse": "15",
          "text": "And Jehozadak went into captivity, when the LORD carried away Judah and Jerusalem by the hand of Nebuchadnezzar."
        },
        {
          "verse": "16",
          "text": "The sons of Levi; Gershom, Kohath, and Merari."
        },
        {
          "verse": "17",
          "text": "And these be the names of the sons of Gershom; Libni, and Shimei."
        },
        {
          "verse": "18",
          "text": "And the sons of Kohath were, Amram, and Izhar, and Hebron, and Uzziel."
        },
        {
          "verse": "19",
          "text": "The sons of Merari; Mahli, and Mushi. And these are the families of the Levites according to their fathers."
        },
        {
          "verse": "20",
          "text": "Of Gershom; Libni his son, Jahath his son, Zimmah his son,"
        },
        {
          "verse": "21",
          "text": "Joah his son, Iddo his son, Zerah his son, Jeaterai his son."
        },
        {
          "verse": "22",
          "text": "The sons of Kohath; Amminadab his son, Korah his son, Assir his son,"
        },
        {
          "verse": "23",
          "text": "Elkanah his son, and Ebiasaph his son, and Assir his son,"
        },
        {
          "verse": "24",
          "text": "Tahath his son, Uriel his son, Uzziah his son, and Shaul his son."
        },
        {
          "verse": "25",
          "text": "And the sons of Elkanah; Amasai, and Ahimoth."
        },
        {
          "verse": "26",
          "text": "As for Elkanah: the sons of Elkanah; Zophai his son, and Nahath his son,"
        },
        {
          "verse": "27",
          "text": "Eliab his son, Jeroham his son, Elkanah his son."
        },
        {
          "verse": "28",
          "text": "And the sons of Samuel; the firstborn Vashni, and Abiah."
        },
        {
          "verse": "29",
          "text": "The sons of Merari; Mahli, Libni his son, Shimei his son, Uzza his son,"
        },
        {
          "verse": "30",
          "text": "Shimea his son, Haggiah his son, Asaiah his son."
        },
        {
          "verse": "31",
          "text": "And these are they whom David set over the service of song in the house of the LORD, after that the ark had rest."
        },
        {
          "verse": "32",
          "text": "And they ministered before the dwelling place of the tabernacle of the congregation with singing, until Solomon had built the house of the LORD in Jerusalem: and then they waited on their office according to their order."
        },
        {
          "verse": "33",
          "text": "And these are they that waited with their children. Of the sons of the Kohathites: Heman a singer, the son of Joel, the son of Shemuel,"
        },
        {
          "verse": "34",
          "text": "The son of Elkanah, the son of Jeroham, the son of Eliel, the son of Toah,"
        },
        {
          "verse": "35",
          "text": "The son of Zuph, the son of Elkanah, the son of Mahath, the son of Amasai,"
        },
        {
          "verse": "36",
          "text": "The son of Elkanah, the son of Joel, the son of Azariah, the son of Zephaniah,"
        },
        {
          "verse": "37",
          "text": "The son of Tahath, the son of Assir, the son of Ebiasaph, the son of Korah,"
        },
        {
          "verse": "38",
          "text": "The son of Izhar, the son of Kohath, the son of Levi, the son of Israel."
        },
        {
          "verse": "39",
          "text": "And his brother Asaph, who stood on his right hand, even Asaph the son of Berachiah, the son of Shimea,"
        },
        {
          "verse": "40",
          "text": "The son of Michael, the son of Baaseiah, the son of Malchiah,"
        },
        {
          "verse": "41",
          "text": "The son of Ethni, the son of Zerah, the son of Adaiah,"
        },
        {
          "verse": "42",
          "text": "The son of Ethan, the son of Zimmah, the son of Shimei,"
        },
        {
          "verse": "43",
          "text": "The son of Jahath, the son of Gershom, the son of Levi."
        },
        {
          "verse": "44",
          "text": "And their brethren the sons of Merari stood on the left hand: Ethan the son of Kishi, the son of Abdi, the son of Malluch,"
        },
        {
          "verse": "45",
          "text": "The son of Hashabiah, the son of Amaziah, the son of Hilkiah,"
        },
        {
          "verse": "46",
          "text": "The son of Amzi, the son of Bani, the son of Shamer,"
        },
        {
          "verse": "47",
          "text": "The son of Mahli, the son of Mushi, the son of Merari, the son of Levi."
        },
        {
          "verse": "48",
          "text": "Their brethren also the Levites were appointed unto all manner of service of the tabernacle of the house of God."
        },
        {
          "verse": "49",
          "text": "But Aaron and his sons offered upon the altar of the burnt offering, and on the altar of incense, and were appointed for all the work of the place most holy, and to make an atonement for Israel, according to all that Moses the servant of God had commanded."
        },
        {
          "verse": "50",
          "text": "And these are the sons of Aaron; Eleazar his son, Phinehas his son, Abishua his son,"
        },
        {
          "verse": "51",
          "text": "Bukki his son, Uzzi his son, Zerahiah his son,"
        },
        {
          "verse": "52",
          "text": "Meraioth his son, Amariah his son, Ahitub his son,"
        },
        { "verse": "53", "text": "Zadok his son, Ahimaaz his son." },
        {
          "verse": "54",
          "text": "Now these are their dwelling places throughout their castles in their coasts, of the sons of Aaron, of the families of the Kohathites: for theirs was the lot."
        },
        {
          "verse": "55",
          "text": "And they gave them Hebron in the land of Judah, and the suburbs thereof round about it."
        },
        {
          "verse": "56",
          "text": "But the fields of the city, and the villages thereof, they gave to Caleb the son of Jephunneh."
        },
        {
          "verse": "57",
          "text": "And to the sons of Aaron they gave the cities of Judah, namely, Hebron, the city of refuge, and Libnah with her suburbs, and Jattir, and Eshtemoa, with their suburbs,"
        },
        {
          "verse": "58",
          "text": "And Hilen with her suburbs, Debir with her suburbs,"
        },
        {
          "verse": "59",
          "text": "And Ashan with her suburbs, and Bethshemesh with her suburbs:"
        },
        {
          "verse": "60",
          "text": "And out of the tribe of Benjamin; Geba with her suburbs, and Alemeth with her suburbs, and Anathoth with her suburbs. All their cities throughout their families were thirteen cities."
        },
        {
          "verse": "61",
          "text": "And unto the sons of Kohath, which were left of the family of that tribe, were cities given out of the half tribe, namely, out of the half tribe of Manasseh, by lot, ten cities."
        },
        {
          "verse": "62",
          "text": "And to the sons of Gershom throughout their families out of the tribe of Issachar, and out of the tribe of Asher, and out of the tribe of Naphtali, and out of the tribe of Manasseh in Bashan, thirteen cities."
        },
        {
          "verse": "63",
          "text": "Unto the sons of Merari were given by lot, throughout their families, out of the tribe of Reuben, and out of the tribe of Gad, and out of the tribe of Zebulun, twelve cities."
        },
        {
          "verse": "64",
          "text": "And the children of Israel gave to the Levites these cities with their suburbs."
        },
        {
          "verse": "65",
          "text": "And they gave by lot out of the tribe of the children of Judah, and out of the tribe of the children of Simeon, and out of the tribe of the children of Benjamin, these cities, which are called by their names."
        },
        {
          "verse": "66",
          "text": "And the residue of the families of the sons of Kohath had cities of their coasts out of the tribe of Ephraim."
        },
        {
          "verse": "67",
          "text": "And they gave unto them, of the cities of refuge, Shechem in mount Ephraim with her suburbs; they gave also Gezer with her suburbs,"
        },
        {
          "verse": "68",
          "text": "And Jokmeam with her suburbs, and Bethhoron with her suburbs,"
        },
        {
          "verse": "69",
          "text": "And Aijalon with her suburbs, and Gathrimmon with her suburbs:"
        },
        {
          "verse": "70",
          "text": "And out of the half tribe of Manasseh; Aner with her suburbs, and Bileam with her suburbs, for the family of the remnant of the sons of Kohath."
        },
        {
          "verse": "71",
          "text": "Unto the sons of Gershom were given out of the family of the half tribe of Manasseh, Golan in Bashan with her suburbs, and Ashtaroth with her suburbs:"
        },
        {
          "verse": "72",
          "text": "And out of the tribe of Issachar; Kedesh with her suburbs, Daberath with her suburbs,"
        },
        {
          "verse": "73",
          "text": "And Ramoth with her suburbs, and Anem with her suburbs:"
        },
        {
          "verse": "74",
          "text": "And out of the tribe of Asher; Mashal with her suburbs, and Abdon with her suburbs,"
        },
        {
          "verse": "75",
          "text": "And Hukok with her suburbs, and Rehob with her suburbs:"
        },
        {
          "verse": "76",
          "text": "And out of the tribe of Naphtali; Kedesh in Galilee with her suburbs, and Hammon with her suburbs, and Kirjathaim with her suburbs."
        },
        {
          "verse": "77",
          "text": "Unto the rest of the children of Merari were given out of the tribe of Zebulun, Rimmon with her suburbs, Tabor with her suburbs:"
        },
        {
          "verse": "78",
          "text": "And on the other side Jordan by Jericho, on the east side of Jordan, were given them out of the tribe of Reuben, Bezer in the wilderness with her suburbs, and Jahzah with her suburbs,"
        },
        {
          "verse": "79",
          "text": "Kedemoth also with her suburbs, and Mephaath with her suburbs:"
        },
        {
          "verse": "80",
          "text": "And out of the tribe of Gad; Ramoth in Gilead with her suburbs, and Mahanaim with her suburbs,"
        },
        {
          "verse": "81",
          "text": "And Heshbon with her suburbs, and Jazer with her suburbs."
        }
      ]
    },
    {
      "chapter": "7",
      "verses": [
        {
          "verse": "1",
          "text": "Now the sons of Issachar were, Tola, and Puah, Jashub, and Shimrom, four."
        },
        {
          "verse": "2",
          "text": "And the sons of Tola; Uzzi, and Rephaiah, and Jeriel, and Jahmai, and Jibsam, and Shemuel, heads of their father\u2019s house, to wit, of Tola: they were valiant men of might in their generations; whose number was in the days of David two and twenty thousand and six hundred."
        },
        {
          "verse": "3",
          "text": "And the sons of Uzzi; Izrahiah: and the sons of Izrahiah; Michael, and Obadiah, and Joel, Ishiah, five: all of them chief men."
        },
        {
          "verse": "4",
          "text": "And with them, by their generations, after the house of their fathers, were bands of soldiers for war, six and thirty thousand men: for they had many wives and sons."
        },
        {
          "verse": "5",
          "text": "And their brethren among all the families of Issachar were valiant men of might, reckoned in all by their genealogies fourscore and seven thousand."
        },
        {
          "verse": "6",
          "text": "The sons of Benjamin; Bela, and Becher, and Jediael, three."
        },
        {
          "verse": "7",
          "text": "And the sons of Bela; Ezbon, and Uzzi, and Uzziel, and Jerimoth, and Iri, five; heads of the house of their fathers, mighty men of valour; and were reckoned by their genealogies twenty and two thousand and thirty and four."
        },
        {
          "verse": "8",
          "text": "And the sons of Becher; Zemira, and Joash, and Eliezer, and Elioenai, and Omri, and Jerimoth, and Abiah, and Anathoth, and Alameth. All these are the sons of Becher."
        },
        {
          "verse": "9",
          "text": "And the number of them, after their genealogy by their generations, heads of the house of their fathers, mighty men of valour, was twenty thousand and two hundred."
        },
        {
          "verse": "10",
          "text": "The sons also of Jediael; Bilhan: and the sons of Bilhan; Jeush, and Benjamin, and Ehud, and Chenaanah, and Zethan, and Tharshish, and Ahishahar."
        },
        {
          "verse": "11",
          "text": "All these the sons of Jediael, by the heads of their fathers, mighty men of valour, were seventeen thousand and two hundred soldiers, fit to go out for war and battle."
        },
        {
          "verse": "12",
          "text": "Shuppim also, and Huppim, the children of Ir, and Hushim, the sons of Aher."
        },
        {
          "verse": "13",
          "text": "The sons of Naphtali; Jahziel, and Guni, and Jezer, and Shallum, the sons of Bilhah."
        },
        {
          "verse": "14",
          "text": "The sons of Manasseh; Ashriel, whom she bare: (but his concubine the Aramitess bare Machir the father of Gilead:"
        },
        {
          "verse": "15",
          "text": "And Machir took to wife the sister of Huppim and Shuppim, whose sister\u2019s name was Maachah;) and the name of the second was Zelophehad: and Zelophehad had daughters."
        },
        {
          "verse": "16",
          "text": "And Maachah the wife of Machir bare a son, and she called his name Peresh; and the name of his brother was Sheresh; and his sons were Ulam and Rakem."
        },
        {
          "verse": "17",
          "text": "And the sons of Ulam; Bedan. These were the sons of Gilead, the son of Machir, the son of Manasseh."
        },
        {
          "verse": "18",
          "text": "And his sister Hammoleketh bare Ishod, and Abiezer, and Mahalah."
        },
        {
          "verse": "19",
          "text": "And the sons of Shemidah were, Ahian, and Shechem, and Likhi, and Aniam."
        },
        {
          "verse": "20",
          "text": "And the sons of Ephraim; Shuthelah, and Bered his son, and Tahath his son, and Eladah his son, and Tahath his son,"
        },
        {
          "verse": "21",
          "text": "And Zabad his son, and Shuthelah his son, and Ezer, and Elead, whom the men of Gath that were born in that land slew, because they came down to take away their cattle."
        },
        {
          "verse": "22",
          "text": "And Ephraim their father mourned many days, and his brethren came to comfort him."
        },
        {
          "verse": "23",
          "text": "And when he went in to his wife, she conceived, and bare a son, and he called his name Beriah, because it went evil with his house."
        },
        {
          "verse": "24",
          "text": "(And his daughter was Sherah, who built Bethhoron the nether, and the upper, and Uzzensherah.)"
        },
        {
          "verse": "25",
          "text": "And Rephah was his son, also Resheph, and Telah his son, and Tahan his son,"
        },
        {
          "verse": "26",
          "text": "Laadan his son, Ammihud his son, Elishama his son,"
        },
        { "verse": "27", "text": "Non his son, Jehoshuah his son," },
        {
          "verse": "28",
          "text": "And their possessions and habitations were, Bethel and the towns thereof, and eastward Naaran, and westward Gezer, with the towns thereof; Shechem also and the towns thereof, unto Gaza and the towns thereof:"
        },
        {
          "verse": "29",
          "text": "And by the borders of the children of Manasseh, Bethshean and her towns, Taanach and her towns, Megiddo and her towns, Dor and her towns. In these dwelt the children of Joseph the son of Israel."
        },
        {
          "verse": "30",
          "text": "The sons of Asher; Imnah, and Isuah, and Ishuai, and Beriah, and Serah their sister."
        },
        {
          "verse": "31",
          "text": "And the sons of Beriah; Heber, and Malchiel, who is the father of Birzavith."
        },
        {
          "verse": "32",
          "text": "And Heber begat Japhlet, and Shomer, and Hotham, and Shua their sister."
        },
        {
          "verse": "33",
          "text": "And the sons of Japhlet; Pasach, and Bimhal, and Ashvath. These are the children of Japhlet."
        },
        {
          "verse": "34",
          "text": "And the sons of Shamer; Ahi, and Rohgah, Jehubbah, and Aram."
        },
        {
          "verse": "35",
          "text": "And the sons of his brother Helem; Zophah, and Imna, and Shelesh, and Amal."
        },
        {
          "verse": "36",
          "text": "The sons of Zophah; Suah, and Harnepher, and Shual, and Beri, and Imrah,"
        },
        {
          "verse": "37",
          "text": "Bezer, and Hod, and Shamma, and Shilshah, and Ithran, and Beera."
        },
        {
          "verse": "38",
          "text": "And the sons of Jether; Jephunneh, and Pispah, and Ara."
        },
        {
          "verse": "39",
          "text": "And the sons of Ulla; Arah, and Haniel, and Rezia."
        },
        {
          "verse": "40",
          "text": "All these were the children of Asher, heads of their father\u2019s house, choice and mighty men of valour, chief of the princes. And the number throughout the genealogy of them that were apt to the war and to battle was twenty and six thousand men."
        }
      ]
    },
    {
      "chapter": "8",
      "verses": [
        {
          "verse": "1",
          "text": "Now Benjamin begat Bela his firstborn, Ashbel the second, and Aharah the third,"
        },
        { "verse": "2", "text": "Nohah the fourth, and Rapha the fifth." },
        {
          "verse": "3",
          "text": "And the sons of Bela were, Addar, and Gera, and Abihud,"
        },
        { "verse": "4", "text": "And Abishua, and Naaman, and Ahoah," },
        { "verse": "5", "text": "And Gera, and Shephuphan, and Huram." },
        {
          "verse": "6",
          "text": "And these are the sons of Ehud: these are the heads of the fathers of the inhabitants of Geba, and they removed them to Manahath:"
        },
        {
          "verse": "7",
          "text": "And Naaman, and Ahiah, and Gera, he removed them, and begat Uzza, and Ahihud."
        },
        {
          "verse": "8",
          "text": "And Shaharaim begat children in the country of Moab, after he had sent them away; Hushim and Baara were his wives."
        },
        {
          "verse": "9",
          "text": "And he begat of Hodesh his wife, Jobab, and Zibia, and Mesha, and Malcham,"
        },
        {
          "verse": "10",
          "text": "And Jeuz, and Shachia, and Mirma. These were his sons, heads of the fathers."
        },
        { "verse": "11", "text": "And of Hushim he begat Abitub, and Elpaal." },
        {
          "verse": "12",
          "text": "The sons of Elpaal; Eber, and Misham, and Shamed, who built Ono, and Lod, with the towns thereof:"
        },
        {
          "verse": "13",
          "text": "Beriah also, and Shema, who were heads of the fathers of the inhabitants of Aijalon, who drove away the inhabitants of Gath:"
        },
        { "verse": "14", "text": "And Ahio, Shashak, and Jeremoth," },
        { "verse": "15", "text": "And Zebadiah, and Arad, and Ader," },
        {
          "verse": "16",
          "text": "And Michael, and Ispah, and Joha, the sons of Beriah;"
        },
        {
          "verse": "17",
          "text": "And Zebadiah, and Meshullam, and Hezeki, and Heber,"
        },
        {
          "verse": "18",
          "text": "Ishmerai also, and Jezliah, and Jobab, the sons of Elpaal;"
        },
        { "verse": "19", "text": "And Jakim, and Zichri, and Zabdi," },
        { "verse": "20", "text": "And Elienai, and Zilthai, and Eliel," },
        {
          "verse": "21",
          "text": "And Adaiah, and Beraiah, and Shimrath, the sons of Shimhi;"
        },
        { "verse": "22", "text": "And Ishpan, and Heber, and Eliel," },
        { "verse": "23", "text": "And Abdon, and Zichri, and Hanan," },
        { "verse": "24", "text": "And Hananiah, and Elam, and Antothijah," },
        {
          "verse": "25",
          "text": "And Iphedeiah, and Penuel, the sons of Shashak;"
        },
        {
          "verse": "26",
          "text": "And Shamsherai, and Shehariah, and Athaliah,"
        },
        {
          "verse": "27",
          "text": "And Jaresiah, and Eliah, and Zichri, the sons of Jeroham."
        },
        {
          "verse": "28",
          "text": "These were heads of the fathers, by their generations, chief men. These dwelt in Jerusalem."
        },
        {
          "verse": "29",
          "text": "And at Gibeon dwelt the father of Gibeon; whose wife\u2019s name was Maachah:"
        },
        {
          "verse": "30",
          "text": "And his firstborn son Abdon, and Zur, and Kish, and Baal, and Nadab,"
        },
        { "verse": "31", "text": "And Gedor, and Ahio, and Zacher." },
        {
          "verse": "32",
          "text": "And Mikloth begat Shimeah. And these also dwelt with their brethren in Jerusalem, over against them."
        },
        {
          "verse": "33",
          "text": "And Ner begat Kish, and Kish begat Saul, and Saul begat Jonathan, and Malchishua, and Abinadab, and Eshbaal."
        },
        {
          "verse": "34",
          "text": "And the son of Jonathan was Meribbaal; and Meribbaal begat Micah."
        },
        {
          "verse": "35",
          "text": "And the sons of Micah were, Pithon, and Melech, and Tarea, and Ahaz."
        },
        {
          "verse": "36",
          "text": "And Ahaz begat Jehoadah; and Jehoadah begat Alemeth, and Azmaveth, and Zimri; and Zimri begat Moza,"
        },
        {
          "verse": "37",
          "text": "And Moza begat Binea: Rapha was his son, Eleasah his son, Azel his son:"
        },
        {
          "verse": "38",
          "text": "And Azel had six sons, whose names are these, Azrikam, Bocheru, and Ishmael, and Sheariah, and Obadiah, and Hanan. All these were the sons of Azel."
        },
        {
          "verse": "39",
          "text": "And the sons of Eshek his brother were, Ulam his firstborn, Jehush the second, and Eliphelet the third."
        },
        {
          "verse": "40",
          "text": "And the sons of Ulam were mighty men of valour, archers, and had many sons, and sons\u2019 sons, an hundred and fifty. All these are of the sons of Benjamin."
        }
      ]
    },
    {
      "chapter": "9",
      "verses": [
        {
          "verse": "1",
          "text": "So all Israel were reckoned by genealogies; and, behold, they were written in the book of the kings of Israel and Judah, who were carried away to Babylon for their transgression."
        },
        {
          "verse": "2",
          "text": "Now the first inhabitants that dwelt in their possessions in their cities were, the Israelites, the priests, Levites, and the Nethinims."
        },
        {
          "verse": "3",
          "text": "And in Jerusalem dwelt of the children of Judah, and of the children of Benjamin, and of the children of Ephraim, and Manasseh;"
        },
        {
          "verse": "4",
          "text": "Uthai the son of Ammihud, the son of Omri, the son of Imri, the son of Bani, of the children of Pharez the son of Judah."
        },
        {
          "verse": "5",
          "text": "And of the Shilonites; Asaiah the firstborn, and his sons."
        },
        {
          "verse": "6",
          "text": "And of the sons of Zerah; Jeuel, and their brethren, six hundred and ninety."
        },
        {
          "verse": "7",
          "text": "And of the sons of Benjamin; Sallu the son of Meshullam, the son of Hodaviah, the son of Hasenuah,"
        },
        {
          "verse": "8",
          "text": "And Ibneiah the son of Jeroham, and Elah the son of Uzzi, the son of Michri, and Meshullam the son of Shephathiah, the son of Reuel, the son of Ibnijah;"
        },
        {
          "verse": "9",
          "text": "And their brethren, according to their generations, nine hundred and fifty and six. All these men were chief of the fathers in the house of their fathers."
        },
        {
          "verse": "10",
          "text": "And of the priests; Jedaiah, and Jehoiarib, and Jachin,"
        },
        {
          "verse": "11",
          "text": "And Azariah the son of Hilkiah, the son of Meshullam, the son of Zadok, the son of Meraioth, the son of Ahitub, the ruler of the house of God;"
        },
        {
          "verse": "12",
          "text": "And Adaiah the son of Jeroham, the son of Pashur, the son of Malchijah, and Maasiai the son of Adiel, the son of Jahzerah, the son of Meshullam, the son of Meshillemith, the son of Immer;"
        },
        {
          "verse": "13",
          "text": "And their brethren, heads of the house of their fathers, a thousand and seven hundred and threescore; very able men for the work of the service of the house of God."
        },
        {
          "verse": "14",
          "text": "And of the Levites; Shemaiah the son of Hasshub, the son of Azrikam, the son of Hashabiah, of the sons of Merari;"
        },
        {
          "verse": "15",
          "text": "And Bakbakkar, Heresh, and Galal, and Mattaniah the son of Micah, the son of Zichri, the son of Asaph;"
        },
        {
          "verse": "16",
          "text": "And Obadiah the son of Shemaiah, the son of Galal, the son of Jeduthun, and Berechiah the son of Asa, the son of Elkanah, that dwelt in the villages of the Netophathites."
        },
        {
          "verse": "17",
          "text": "And the porters were, Shallum, and Akkub, and Talmon, and Ahiman, and their brethren: Shallum was the chief;"
        },
        {
          "verse": "18",
          "text": "Who hitherto waited in the king\u2019s gate eastward: they were porters in the companies of the children of Levi."
        },
        {
          "verse": "19",
          "text": "And Shallum the son of Kore, the son of Ebiasaph, the son of Korah, and his brethren, of the house of his father, the Korahites, were over the work of the service, keepers of the gates of the tabernacle: and their fathers, being over the host of the LORD, were keepers of the entry."
        },
        {
          "verse": "20",
          "text": "And Phinehas the son of Eleazar was the ruler over them in time past, and the LORD was with him."
        },
        {
          "verse": "21",
          "text": "And Zechariah the son of Meshelemiah was porter of the door of the tabernacle of the congregation."
        },
        {
          "verse": "22",
          "text": "All these which were chosen to be porters in the gates were two hundred and twelve. These were reckoned by their genealogy in their villages, whom David and Samuel the seer did ordain in their set office."
        },
        {
          "verse": "23",
          "text": "So they and their children had the oversight of the gates of the house of the LORD, namely, the house of the tabernacle, by wards."
        },
        {
          "verse": "24",
          "text": "In four quarters were the porters, toward the east, west, north, and south."
        },
        {
          "verse": "25",
          "text": "And their brethren, which were in their villages, were to come after seven days from time to time with them."
        },
        {
          "verse": "26",
          "text": "For these Levites, the four chief porters, were in their set office, and were over the chambers and treasuries of the house of God."
        },
        {
          "verse": "27",
          "text": "And they lodged round about the house of God, because the charge was upon them, and the opening thereof every morning pertained to them."
        },
        {
          "verse": "28",
          "text": "And certain of them had the charge of the ministering vessels, that they should bring them in and out by tale."
        },
        {
          "verse": "29",
          "text": "Some of them also were appointed to oversee the vessels, and all the instruments of the sanctuary, and the fine flour, and the wine, and the oil, and the frankincense, and the spices."
        },
        {
          "verse": "30",
          "text": "And some of the sons of the priests made the ointment of the spices."
        },
        {
          "verse": "31",
          "text": "And Mattithiah, one of the Levites, who was the firstborn of Shallum the Korahite, had the set office over the things that were made in the pans."
        },
        {
          "verse": "32",
          "text": "And other of their brethren, of the sons of the Kohathites, were over the shewbread, to prepare it every sabbath."
        },
        {
          "verse": "33",
          "text": "And these are the singers, chief of the fathers of the Levites, who remaining in the chambers were free: for they were employed in that work day and night."
        },
        {
          "verse": "34",
          "text": "These chief fathers of the Levites were chief throughout their generations; these dwelt at Jerusalem."
        },
        {
          "verse": "35",
          "text": "And in Gibeon dwelt the father of Gibeon, Jehiel, whose wife\u2019s name was Maachah,"
        },
        {
          "verse": "36",
          "text": "And his firstborn son Abdon, then Zur, and Kish, and Baal, and Ner, and Nadab,"
        },
        {
          "verse": "37",
          "text": "And Gedor, and Ahio, and Zechariah, and Mikloth."
        },
        {
          "verse": "38",
          "text": "And Mikloth begat Shimeam. And they also dwelt with their brethren at Jerusalem, over against their brethren."
        },
        {
          "verse": "39",
          "text": "And Ner begat Kish; and Kish begat Saul; and Saul begat Jonathan, and Malchishua, and Abinadab, and Eshbaal."
        },
        {
          "verse": "40",
          "text": "And the son of Jonathan was Meribbaal: and Meribbaal begat Micah."
        },
        {
          "verse": "41",
          "text": "And the sons of Micah were, Pithon, and Melech, and Tahrea, and Ahaz."
        },
        {
          "verse": "42",
          "text": "And Ahaz begat Jarah; and Jarah begat Alemeth, and Azmaveth, and Zimri; and Zimri begat Moza;"
        },
        {
          "verse": "43",
          "text": "And Moza begat Binea; and Rephaiah his son, Eleasah his son, Azel his son."
        },
        {
          "verse": "44",
          "text": "And Azel had six sons, whose names are these, Azrikam, Bocheru, and Ishmael, and Sheariah, and Obadiah, and Hanan: these were the sons of Azel."
        }
      ]
    },
    {
      "chapter": "10",
      "verses": [
        {
          "verse": "1",
          "text": "Now the Philistines fought against Israel; and the men of Israel fled from before the Philistines, and fell down slain in mount Gilboa."
        },
        {
          "verse": "2",
          "text": "And the Philistines followed hard after Saul, and after his sons; and the Philistines slew Jonathan, and Abinadab, and Malchishua, the sons of Saul."
        },
        {
          "verse": "3",
          "text": "And the battle went sore against Saul, and the archers hit him, and he was wounded of the archers."
        },
        {
          "verse": "4",
          "text": "Then said Saul to his armourbearer, Draw thy sword, and thrust me through therewith; lest these uncircumcised come and abuse me. But his armourbearer would not; for he was sore afraid. So Saul took a sword, and fell upon it."
        },
        {
          "verse": "5",
          "text": "And when his armourbearer saw that Saul was dead, he fell likewise on the sword, and died."
        },
        {
          "verse": "6",
          "text": "So Saul died, and his three sons, and all his house died together."
        },
        {
          "verse": "7",
          "text": "And when all the men of Israel that were in the valley saw that they fled, and that Saul and his sons were dead, then they forsook their cities, and fled: and the Philistines came and dwelt in them."
        },
        {
          "verse": "8",
          "text": "And it came to pass on the morrow, when the Philistines came to strip the slain, that they found Saul and his sons fallen in mount Gilboa."
        },
        {
          "verse": "9",
          "text": "And when they had stripped him, they took his head, and his armour, and sent into the land of the Philistines round about, to carry tidings unto their idols, and to the people."
        },
        {
          "verse": "10",
          "text": "And they put his armour in the house of their gods, and fastened his head in the temple of Dagon."
        },
        {
          "verse": "11",
          "text": "And when all Jabeshgilead heard all that the Philistines had done to Saul,"
        },
        {
          "verse": "12",
          "text": "They arose, all the valiant men, and took away the body of Saul, and the bodies of his sons, and brought them to Jabesh, and buried their bones under the oak in Jabesh, and fasted seven days."
        },
        {
          "verse": "13",
          "text": "So Saul died for his transgression which he committed against the LORD, even against the word of the LORD, which he kept not, and also for asking counsel of one that had a familiar spirit, to enquire of it;"
        },
        {
          "verse": "14",
          "text": "And enquired not of the LORD: therefore he slew him, and turned the kingdom unto David the son of Jesse."
        }
      ]
    },
    {
      "chapter": "11",
      "verses": [
        {
          "verse": "1",
          "text": "Then all Israel gathered themselves to David unto Hebron, saying, Behold, we are thy bone and thy flesh."
        },
        {
          "verse": "2",
          "text": "And moreover in time past, even when Saul was king, thou wast he that leddest out and broughtest in Israel: and the LORD thy God said unto thee, Thou shalt feed my people Israel, and thou shalt be ruler over my people Israel."
        },
        {
          "verse": "3",
          "text": "Therefore came all the elders of Israel to the king to Hebron; and David made a covenant with them in Hebron before the LORD; and they anointed David king over Israel, according to the word of the LORD by Samuel."
        },
        {
          "verse": "4",
          "text": "And David and all Israel went to Jerusalem, which is Jebus; where the Jebusites were, the inhabitants of the land."
        },
        {
          "verse": "5",
          "text": "And the inhabitants of Jebus said to David, Thou shalt not come hither. Nevertheless David took the castle of Zion, which is the city of David."
        },
        {
          "verse": "6",
          "text": "And David said, Whosoever smiteth the Jebusites first shall be chief and captain. So Joab the son of Zeruiah went first up, and was chief."
        },
        {
          "verse": "7",
          "text": "And David dwelt in the castle; therefore they called it the city of David."
        },
        {
          "verse": "8",
          "text": "And he built the city round about, even from Millo round about: and Joab repaired the rest of the city."
        },
        {
          "verse": "9",
          "text": "So David waxed greater and greater: for the LORD of hosts was with him."
        },
        {
          "verse": "10",
          "text": "These also are the chief of the mighty men whom David had, who strengthened themselves with him in his kingdom, and with all Israel, to make him king, according to the word of the LORD concerning Israel."
        },
        {
          "verse": "11",
          "text": "And this is the number of the mighty men whom David had; Jashobeam, an Hachmonite, the chief of the captains: he lifted up his spear against three hundred slain by him at one time."
        },
        {
          "verse": "12",
          "text": "And after him was Eleazar the son of Dodo, the Ahohite, who was one of the three mighties."
        },
        {
          "verse": "13",
          "text": "He was with David at Pasdammim, and there the Philistines were gathered together to battle, where was a parcel of ground full of barley; and the people fled from before the Philistines."
        },
        {
          "verse": "14",
          "text": "And they set themselves in the midst of that parcel, and delivered it, and slew the Philistines; and the LORD saved them by a great deliverance."
        },
        {
          "verse": "15",
          "text": "Now three of the thirty captains went down to the rock to David, into the cave of Adullam; and the host of the Philistines encamped in the valley of Rephaim."
        },
        {
          "verse": "16",
          "text": "And David was then in the hold, and the Philistines\u2019 garrison was then at Bethlehem."
        },
        {
          "verse": "17",
          "text": "And David longed, and said, Oh that one would give me drink of the water of the well of Bethlehem, that is at the gate!"
        },
        {
          "verse": "18",
          "text": "And the three brake through the host of the Philistines, and drew water out of the well of Bethlehem, that was by the gate, and took it, and brought it to David: but David would not drink of it, but poured it out to the LORD,"
        },
        {
          "verse": "19",
          "text": "And said, My God forbid it me, that I should do this thing: shall I drink the blood of these men that have put their lives in jeopardy? for with the jeopardy of their lives they brought it. Therefore he would not drink it. These things did these three mightiest."
        },
        {
          "verse": "20",
          "text": "And Abishai the brother of Joab, he was chief of the three: for lifting up his spear against three hundred, he slew them, and had a name among the three."
        },
        {
          "verse": "21",
          "text": "Of the three, he was more honourable than the two; for he was their captain: howbeit he attained not to the first three."
        },
        {
          "verse": "22",
          "text": "Benaiah the son of Jehoiada, the son of a valiant man of Kabzeel, who had done many acts; he slew two lionlike men of Moab: also he went down and slew a lion in a pit in a snowy day."
        },
        {
          "verse": "23",
          "text": "And he slew an Egyptian, a man of great stature, five cubits high; and in the Egyptian\u2019s hand was a spear like a weaver\u2019s beam; and he went down to him with a staff, and plucked the spear out of the Egyptian\u2019s hand, and slew him with his own spear."
        },
        {
          "verse": "24",
          "text": "These things did Benaiah the son of Jehoiada, and had the name among the three mighties."
        },
        {
          "verse": "25",
          "text": "Behold, he was honourable among the thirty, but attained not to the first three: and David set him over his guard."
        },
        {
          "verse": "26",
          "text": "Also the valiant men of the armies were, Asahel the brother of Joab, Elhanan the son of Dodo of Bethlehem,"
        },
        { "verse": "27", "text": "Shammoth the Harorite, Helez the Pelonite," },
        {
          "verse": "28",
          "text": "Ira the son of Ikkesh the Tekoite, Abiezer the Antothite,"
        },
        { "verse": "29", "text": "Sibbecai the Hushathite, Ilai the Ahohite," },
        {
          "verse": "30",
          "text": "Maharai the Netophathite, Heled the son of Baanah the Netophathite,"
        },
        {
          "verse": "31",
          "text": "Ithai the son of Ribai of Gibeah, that pertained to the children of Benjamin, Benaiah the Pirathonite,"
        },
        {
          "verse": "32",
          "text": "Hurai of the brooks of Gaash, Abiel the Arbathite,"
        },
        {
          "verse": "33",
          "text": "Azmaveth the Baharumite, Eliahba the Shaalbonite,"
        },
        {
          "verse": "34",
          "text": "The sons of Hashem the Gizonite, Jonathan the son of Shage the Hararite,"
        },
        {
          "verse": "35",
          "text": "Ahiam the son of Sacar the Hararite, Eliphal the son of Ur,"
        },
        {
          "verse": "36",
          "text": "Hepher the Mecherathite, Ahijah the Pelonite,"
        },
        {
          "verse": "37",
          "text": "Hezro the Carmelite, Naarai the son of Ezbai,"
        },
        {
          "verse": "38",
          "text": "Joel the brother of Nathan, Mibhar the son of Haggeri,"
        },
        {
          "verse": "39",
          "text": "Zelek the Ammonite, Naharai the Berothite, the armourbearer of Joab the son of Zeruiah,"
        },
        { "verse": "40", "text": "Ira the Ithrite, Gareb the Ithrite," },
        { "verse": "41", "text": "Uriah the Hittite, Zabad the son of Ahlai," },
        {
          "verse": "42",
          "text": "Adina the son of Shiza the Reubenite, a captain of the Reubenites, and thirty with him,"
        },
        {
          "verse": "43",
          "text": "Hanan the son of Maachah, and Joshaphat the Mithnite,"
        },
        {
          "verse": "44",
          "text": "Uzzia the Ashterathite, Shama and Jehiel the sons of Hothan the Aroerite,"
        },
        {
          "verse": "45",
          "text": "Jediael the son of Shimri, and Joha his brother, the Tizite,"
        },
        {
          "verse": "46",
          "text": "Eliel the Mahavite, and Jeribai, and Joshaviah, the sons of Elnaam, and Ithmah the Moabite,"
        },
        { "verse": "47", "text": "Eliel, and Obed, and Jasiel the Mesobaite." }
      ]
    },
    {
      "chapter": "12",
      "verses": [
        {
          "verse": "1",
          "text": "Now these are they that came to David to Ziklag, while he yet kept himself close because of Saul the son of Kish: and they were among the mighty men, helpers of the war."
        },
        {
          "verse": "2",
          "text": "They were armed with bows, and could use both the right hand and the left in hurling stones and shooting arrows out of a bow, even of Saul\u2019s brethren of Benjamin."
        },
        {
          "verse": "3",
          "text": "The chief was Ahiezer, then Joash, the sons of Shemaah the Gibeathite; and Jeziel, and Pelet, the sons of Azmaveth; and Berachah, and Jehu the Antothite,"
        },
        {
          "verse": "4",
          "text": "And Ismaiah the Gibeonite, a mighty man among the thirty, and over the thirty; and Jeremiah, and Jahaziel, and Johanan, and Josabad the Gederathite,"
        },
        {
          "verse": "5",
          "text": "Eluzai, and Jerimoth, and Bealiah, and Shemariah, and Shephatiah the Haruphite,"
        },
        {
          "verse": "6",
          "text": "Elkanah, and Jesiah, and Azareel, and Joezer, and Jashobeam, the Korhites,"
        },
        {
          "verse": "7",
          "text": "And Joelah, and Zebadiah, the sons of Jeroham of Gedor."
        },
        {
          "verse": "8",
          "text": "And of the Gadites there separated themselves unto David into the hold to the wilderness men of might, and men of war fit for the battle, that could handle shield and buckler, whose faces were like the faces of lions, and were as swift as the roes upon the mountains;"
        },
        {
          "verse": "9",
          "text": "Ezer the first, Obadiah the second, Eliab the third,"
        },
        { "verse": "10", "text": "Mishmannah the fourth, Jeremiah the fifth," },
        { "verse": "11", "text": "Attai the sixth, Eliel the seventh," },
        { "verse": "12", "text": "Johanan the eighth, Elzabad the ninth," },
        {
          "verse": "13",
          "text": "Jeremiah the tenth, Machbanai the eleventh."
        },
        {
          "verse": "14",
          "text": "These were of the sons of Gad, captains of the host: one of the least was over an hundred, and the greatest over a thousand."
        },
        {
          "verse": "15",
          "text": "These are they that went over Jordan in the first month, when it had overflown all his banks; and they put to flight all them of the valleys, both toward the east, and toward the west."
        },
        {
          "verse": "16",
          "text": "And there came of the children of Benjamin and Judah to the hold unto David."
        },
        {
          "verse": "17",
          "text": "And David went out to meet them, and answered and said unto them, If ye be come peaceably unto me to help me, mine heart shall be knit unto you: but if ye be come to betray me to mine enemies, seeing there is no wrong in mine hands, the God of our fathers look thereon, and rebuke it."
        },
        {
          "verse": "18",
          "text": "Then the spirit came upon Amasai, who was chief of the captains, and he said, Thine are we, David, and on thy side, thou son of Jesse: peace, peace be unto thee, and peace be to thine helpers; for thy God helpeth thee. Then David received them, and made them captains of the band."
        },
        {
          "verse": "19",
          "text": "And there fell some of Manasseh to David, when he came with the Philistines against Saul to battle: but they helped them not: for the lords of the Philistines upon advisement sent him away, saying, He will fall to his master Saul to the jeopardy of our heads."
        },
        {
          "verse": "20",
          "text": "As he went to Ziklag, there fell to him of Manasseh, Adnah, and Jozabad, and Jediael, and Michael, and Jozabad, and Elihu, and Zilthai, captains of the thousands that were of Manasseh."
        },
        {
          "verse": "21",
          "text": "And they helped David against the band of the rovers: for they were all mighty men of valour, and were captains in the host."
        },
        {
          "verse": "22",
          "text": "For at that time day by day there came to David to help him, until it was a great host, like the host of God."
        },
        {
          "verse": "23",
          "text": "And these are the numbers of the bands that were ready armed to the war, and came to David to Hebron, to turn the kingdom of Saul to him, according to the word of the LORD."
        },
        {
          "verse": "24",
          "text": "The children of Judah that bare shield and spear were six thousand and eight hundred, ready armed to the war."
        },
        {
          "verse": "25",
          "text": "Of the children of Simeon, mighty men of valour for the war, seven thousand and one hundred."
        },
        {
          "verse": "26",
          "text": "Of the children of Levi four thousand and six hundred."
        },
        {
          "verse": "27",
          "text": "And Jehoiada was the leader of the Aaronites, and with him were three thousand and seven hundred;"
        },
        {
          "verse": "28",
          "text": "And Zadok, a young man mighty of valour, and of his father\u2019s house twenty and two captains."
        },
        {
          "verse": "29",
          "text": "And of the children of Benjamin, the kindred of Saul, three thousand: for hitherto the greatest part of them had kept the ward of the house of Saul."
        },
        {
          "verse": "30",
          "text": "And of the children of Ephraim twenty thousand and eight hundred, mighty men of valour, famous throughout the house of their fathers."
        },
        {
          "verse": "31",
          "text": "And of the half tribe of Manasseh eighteen thousand, which were expressed by name, to come and make David king."
        },
        {
          "verse": "32",
          "text": "And of the children of Issachar, which were men that had understanding of the times, to know what Israel ought to do; the heads of them were two hundred; and all their brethren were at their commandment."
        },
        {
          "verse": "33",
          "text": "Of Zebulun, such as went forth to battle, expert in war, with all instruments of war, fifty thousand, which could keep rank: they were not of double heart."
        },
        {
          "verse": "34",
          "text": "And of Naphtali a thousand captains, and with them with shield and spear thirty and seven thousand."
        },
        {
          "verse": "35",
          "text": "And of the Danites expert in war twenty and eight thousand and six hundred."
        },
        {
          "verse": "36",
          "text": "And of Asher, such as went forth to battle, expert in war, forty thousand."
        },
        {
          "verse": "37",
          "text": "And on the other side of Jordan, of the Reubenites, and the Gadites, and of the half tribe of Manasseh, with all manner of instruments of war for the battle, an hundred and twenty thousand."
        },
        {
          "verse": "38",
          "text": "All these men of war, that could keep rank, came with a perfect heart to Hebron, to make David king over all Israel: and all the rest also of Israel were of one heart to make David king."
        },
        {
          "verse": "39",
          "text": "And there they were with David three days, eating and drinking: for their brethren had prepared for them."
        },
        {
          "verse": "40",
          "text": "Moreover they that were nigh them, even unto Issachar and Zebulun and Naphtali, brought bread on asses, and on camels, and on mules, and on oxen, and meat, meal, cakes of figs, and bunches of raisins, and wine, and oil, and oxen, and sheep abundantly: for there was joy in Israel."
        }
      ]
    },
    {
      "chapter": "13",
      "verses": [
        {
          "verse": "1",
          "text": "And David consulted with the captains of thousands and hundreds, and with every leader."
        },
        {
          "verse": "2",
          "text": "And David said unto all the congregation of Israel, If it seem good unto you, and that it be of the LORD our God, let us send abroad unto our brethren every where, that are left in all the land of Israel, and with them also to the priests and Levites which are in their cities and suburbs, that they may gather themselves unto us:"
        },
        {
          "verse": "3",
          "text": "And let us bring again the ark of our God to us: for we enquired not at it in the days of Saul."
        },
        {
          "verse": "4",
          "text": "And all the congregation said that they would do so: for the thing was right in the eyes of all the people."
        },
        {
          "verse": "5",
          "text": "So David gathered all Israel together, from Shihor of Egypt even unto the entering of Hemath, to bring the ark of God from Kirjathjearim."
        },
        {
          "verse": "6",
          "text": "And David went up, and all Israel, to Baalah, that is, to Kirjathjearim, which belonged to Judah, to bring up thence the ark of God the LORD, that dwelleth between the cherubims, whose name is called on it."
        },
        {
          "verse": "7",
          "text": "And they carried the ark of God in a new cart out of the house of Abinadab: and Uzza and Ahio drave the cart."
        },
        {
          "verse": "8",
          "text": "And David and all Israel played before God with all their might, and with singing, and with harps, and with psalteries, and with timbrels, and with cymbals, and with trumpets."
        },
        {
          "verse": "9",
          "text": "And when they came unto the threshingfloor of Chidon, Uzza put forth his hand to hold the ark; for the oxen stumbled."
        },
        {
          "verse": "10",
          "text": "And the anger of the LORD was kindled against Uzza, and he smote him, because he put his hand to the ark: and there he died before God."
        },
        {
          "verse": "11",
          "text": "And David was displeased, because the LORD had made a breach upon Uzza: wherefore that place is called Perezuzza to this day."
        },
        {
          "verse": "12",
          "text": "And David was afraid of God that day, saying, How shall I bring the ark of God home to me?"
        },
        {
          "verse": "13",
          "text": "So David brought not the ark home to himself to the city of David, but carried it aside into the house of Obededom the Gittite."
        },
        {
          "verse": "14",
          "text": "And the ark of God remained with the family of Obededom in his house three months. And the LORD blessed the house of Obededom, and all that he had."
        }
      ]
    },
    {
      "chapter": "14",
      "verses": [
        {
          "verse": "1",
          "text": "Now Hiram king of Tyre sent messengers to David, and timber of cedars, with masons and carpenters, to build him an house."
        },
        {
          "verse": "2",
          "text": "And David perceived that the LORD had confirmed him king over Israel, for his kingdom was lifted up on high, because of his people Israel."
        },
        {
          "verse": "3",
          "text": "And David took more wives at Jerusalem: and David begat more sons and daughters."
        },
        {
          "verse": "4",
          "text": "Now these are the names of his children which he had in Jerusalem; Shammua, and Shobab, Nathan, and Solomon,"
        },
        { "verse": "5", "text": "And Ibhar, and Elishua, and Elpalet," },
        { "verse": "6", "text": "And Nogah, and Nepheg, and Japhia," },
        { "verse": "7", "text": "And Elishama, and Beeliada, and Eliphalet." },
        {
          "verse": "8",
          "text": "And when the Philistines heard that David was anointed king over all Israel, all the Philistines went up to seek David. And David heard of it, and went out against them."
        },
        {
          "verse": "9",
          "text": "And the Philistines came and spread themselves in the valley of Rephaim."
        },
        {
          "verse": "10",
          "text": "And David enquired of God, saying, Shall I go up against the Philistines? And wilt thou deliver them into mine hand? And the LORD said unto him, Go up; for I will deliver them into thine hand."
        },
        {
          "verse": "11",
          "text": "So they came up to Baalperazim; and David smote them there. Then David said, God hath broken in upon mine enemies by mine hand like the breaking forth of waters: therefore they called the name of that place Baalperazim."
        },
        {
          "verse": "12",
          "text": "And when they had left their gods there, David gave a commandment, and they were burned with fire."
        },
        {
          "verse": "13",
          "text": "And the Philistines yet again spread themselves abroad in the valley."
        },
        {
          "verse": "14",
          "text": "Therefore David enquired again of God; and God said unto him, Go not up after them; turn away from them, and come upon them over against the mulberry trees."
        },
        {
          "verse": "15",
          "text": "And it shall be, when thou shalt hear a sound of going in the tops of the mulberry trees, that then thou shalt go out to battle: for God is gone forth before thee to smite the host of the Philistines."
        },
        {
          "verse": "16",
          "text": "David therefore did as God commanded him: and they smote the host of the Philistines from Gibeon even to Gazer."
        },
        {
          "verse": "17",
          "text": "And the fame of David went out into all lands; and the LORD brought the fear of him upon all nations."
        }
      ]
    },
    {
      "chapter": "15",
      "verses": [
        {
          "verse": "1",
          "text": "And David made him houses in the city of David, and prepared a place for the ark of God, and pitched for it a tent."
        },
        {
          "verse": "2",
          "text": "Then David said, None ought to carry the ark of God but the Levites: for them hath the LORD chosen to carry the ark of God, and to minister unto him for ever."
        },
        {
          "verse": "3",
          "text": "And David gathered all Israel together to Jerusalem, to bring up the ark of the LORD unto his place, which he had prepared for it."
        },
        {
          "verse": "4",
          "text": "And David assembled the children of Aaron, and the Levites:"
        },
        {
          "verse": "5",
          "text": "Of the sons of Kohath; Uriel the chief, and his brethren an hundred and twenty:"
        },
        {
          "verse": "6",
          "text": "Of the sons of Merari; Asaiah the chief, and his brethren two hundred and twenty:"
        },
        {
          "verse": "7",
          "text": "Of the sons of Gershom; Joel the chief, and his brethren an hundred and thirty:"
        },
        {
          "verse": "8",
          "text": "Of the sons of Elizaphan; Shemaiah the chief, and his brethren two hundred:"
        },
        {
          "verse": "9",
          "text": "Of the sons of Hebron; Eliel the chief, and his brethren fourscore:"
        },
        {
          "verse": "10",
          "text": "Of the sons of Uzziel; Amminadab the chief, and his brethren an hundred and twelve."
        },
        {
          "verse": "11",
          "text": "And David called for Zadok and Abiathar the priests, and for the Levites, for Uriel, Asaiah, and Joel, Shemaiah, and Eliel, and Amminadab,"
        },
        {
          "verse": "12",
          "text": "And said unto them, Ye are the chief of the fathers of the Levites: sanctify yourselves, both ye and your brethren, that ye may bring up the ark of the LORD God of Israel unto the place that I have prepared for it."
        },
        {
          "verse": "13",
          "text": "For because ye did it not at the first, the LORD our God made a breach upon us, for that we sought him not after the due order."
        },
        {
          "verse": "14",
          "text": "So the priests and the Levites sanctified themselves to bring up the ark of the LORD God of Israel."
        },
        {
          "verse": "15",
          "text": "And the children of the Levites bare the ark of God upon their shoulders with the staves thereon, as Moses commanded according to the word of the LORD."
        },
        {
          "verse": "16",
          "text": "And David spake to the chief of the Levites to appoint their brethren to be the singers with instruments of musick, psalteries and harps and cymbals, sounding, by lifting up the voice with joy."
        },
        {
          "verse": "17",
          "text": "So the Levites appointed Heman the son of Joel; and of his brethren, Asaph the son of Berechiah; and of the sons of Merari their brethren, Ethan the son of Kushaiah;"
        },
        {
          "verse": "18",
          "text": "And with them their brethren of the second degree, Zechariah, Ben, and Jaaziel, and Shemiramoth, and Jehiel, and Unni, Eliab, and Benaiah, and Maaseiah, and Mattithiah, and Elipheleh, and Mikneiah, and Obededom, and Jeiel, the porters."
        },
        {
          "verse": "19",
          "text": "So the singers, Heman, Asaph, and Ethan, were appointed to sound with cymbals of brass;"
        },
        {
          "verse": "20",
          "text": "And Zechariah, and Aziel, and Shemiramoth, and Jehiel, and Unni, and Eliab, and Maaseiah, and Benaiah, with psalteries on Alamoth;"
        },
        {
          "verse": "21",
          "text": "And Mattithiah, and Elipheleh, and Mikneiah, and Obededom, and Jeiel, and Azaziah, with harps on the Sheminith to excel."
        },
        {
          "verse": "22",
          "text": "And Chenaniah, chief of the Levites, was for song: he instructed about the song, because he was skilful."
        },
        {
          "verse": "23",
          "text": "And Berechiah and Elkanah were doorkeepers for the ark."
        },
        {
          "verse": "24",
          "text": "And Shebaniah, and Jehoshaphat, and Nethaneel, and Amasai, and Zechariah, and Benaiah, and Eliezer, the priests, did blow with the trumpets before the ark of God: and Obededom and Jehiah were doorkeepers for the ark."
        },
        {
          "verse": "25",
          "text": "So David, and the elders of Israel, and the captains over thousands, went to bring up the ark of the covenant of the LORD out of the house of Obededom with joy."
        },
        {
          "verse": "26",
          "text": "And it came to pass, when God helped the Levites that bare the ark of the covenant of the LORD, that they offered seven bullocks and seven rams."
        },
        {
          "verse": "27",
          "text": "And David was clothed with a robe of fine linen, and all the Levites that bare the ark, and the singers, and Chenaniah the master of the song with the singers: David also had upon him an ephod of linen."
        },
        {
          "verse": "28",
          "text": "Thus all Israel brought up the ark of the covenant of the LORD with shouting, and with sound of the cornet, and with trumpets, and with cymbals, making a noise with psalteries and harps."
        },
        {
          "verse": "29",
          "text": "And it came to pass, as the ark of the covenant of the LORD came to the city of David, that Michal, the daughter of Saul looking out at a window saw king David dancing and playing: and she despised him in her heart."
        }
      ]
    },
    {
      "chapter": "16",
      "verses": [
        {
          "verse": "1",
          "text": "So they brought the ark of God, and set it in the midst of the tent that David had pitched for it: and they offered burnt sacrifices and peace offerings before God."
        },
        {
          "verse": "2",
          "text": "And when David had made an end of offering the burnt offerings and the peace offerings, he blessed the people in the name of the LORD."
        },
        {
          "verse": "3",
          "text": "And he dealt to every one of Israel, both man and woman, to every one a loaf of bread, and a good piece of flesh, and a flagon of wine."
        },
        {
          "verse": "4",
          "text": "And he appointed certain of the Levites to minister before the ark of the LORD, and to record, and to thank and praise the LORD God of Israel:"
        },
        {
          "verse": "5",
          "text": "Asaph the chief, and next to him Zechariah, Jeiel, and Shemiramoth, and Jehiel, and Mattithiah, and Eliab, and Benaiah, and Obededom: and Jeiel with psalteries and with harps; but Asaph made a sound with cymbals;"
        },
        {
          "verse": "6",
          "text": "Benaiah also and Jahaziel the priests with trumpets continually before the ark of the covenant of God."
        },
        {
          "verse": "7",
          "text": "Then on that day David delivered first this psalm to thank the LORD into the hand of Asaph and his brethren."
        },
        {
          "verse": "8",
          "text": "Give thanks unto the LORD, call upon his name, make known his deeds among the people."
        },
        {
          "verse": "9",
          "text": "Sing unto him, sing psalms unto him, talk ye of all his wondrous works."
        },
        {
          "verse": "10",
          "text": "Glory ye in his holy name: let the heart of them rejoice that seek the LORD."
        },
        {
          "verse": "11",
          "text": "Seek the LORD and his strength, seek his face continually."
        },
        {
          "verse": "12",
          "text": "Remember his marvellous works that he hath done, his wonders, and the judgments of his mouth;"
        },
        {
          "verse": "13",
          "text": "O ye seed of Israel his servant, ye children of Jacob, his chosen ones."
        },
        {
          "verse": "14",
          "text": "He is the LORD our God; his judgments are in all the earth."
        },
        {
          "verse": "15",
          "text": "Be ye mindful always of his covenant; the word which he commanded to a thousand generations;"
        },
        {
          "verse": "16",
          "text": "Even of the covenant which he made with Abraham, and of his oath unto Isaac;"
        },
        {
          "verse": "17",
          "text": "And hath confirmed the same to Jacob for a law, and to Israel for an everlasting covenant,"
        },
        {
          "verse": "18",
          "text": "Saying, Unto thee will I give the land of Canaan, the lot of your inheritance;"
        },
        {
          "verse": "19",
          "text": "When ye were but few, even a few, and strangers in it."
        },
        {
          "verse": "20",
          "text": "And when they went from nation to nation, and from one kingdom to another people;"
        },
        {
          "verse": "21",
          "text": "He suffered no man to do them wrong: yea, he reproved kings for their sakes,"
        },
        {
          "verse": "22",
          "text": "Saying, Touch not mine anointed, and do my prophets no harm."
        },
        {
          "verse": "23",
          "text": "Sing unto the LORD, all the earth; shew forth from day to day his salvation."
        },
        {
          "verse": "24",
          "text": "Declare his glory among the heathen; his marvellous works among all nations."
        },
        {
          "verse": "25",
          "text": "For great is the LORD, and greatly to be praised: he also is to be feared above all gods."
        },
        {
          "verse": "26",
          "text": "For all the gods of the people are idols: but the LORD made the heavens."
        },
        {
          "verse": "27",
          "text": "Glory and honour are in his presence; strength and gladness are in his place."
        },
        {
          "verse": "28",
          "text": "Give unto the LORD, ye kindreds of the people, give unto the LORD glory and strength."
        },
        {
          "verse": "29",
          "text": "Give unto the LORD the glory due unto his name: bring an offering, and come before him: worship the LORD in the beauty of holiness."
        },
        {
          "verse": "30",
          "text": "Fear before him, all the earth: the world also shall be stable, that it be not moved."
        },
        {
          "verse": "31",
          "text": "Let the heavens be glad, and let the earth rejoice: and let men say among the nations, The LORD reigneth."
        },
        {
          "verse": "32",
          "text": "Let the sea roar, and the fulness thereof: let the fields rejoice, and all that is therein."
        },
        {
          "verse": "33",
          "text": "Then shall the trees of the wood sing out at the presence of the LORD, because he cometh to judge the earth."
        },
        {
          "verse": "34",
          "text": "O give thanks unto the LORD; for he is good; for his mercy endureth for ever."
        },
        {
          "verse": "35",
          "text": "And say ye, Save us, O God of our salvation, and gather us together, and deliver us from the heathen, that we may give thanks to thy holy name, and glory in thy praise."
        },
        {
          "verse": "36",
          "text": "Blessed be the LORD God of Israel for ever and ever. And all the people said, Amen, and praised the LORD."
        },
        {
          "verse": "37",
          "text": "So he left there before the ark of the covenant of the LORD Asaph and his brethren, to minister before the ark continually, as every day\u2019s work required:"
        },
        {
          "verse": "38",
          "text": "And Obededom with their brethren, threescore and eight; Obededom also the son of Jeduthun and Hosah to be porters:"
        },
        {
          "verse": "39",
          "text": "And Zadok the priest, and his brethren the priests, before the tabernacle of the LORD in the high place that was at Gibeon,"
        },
        {
          "verse": "40",
          "text": "To offer burnt offerings unto the LORD upon the altar of the burnt offering continually morning and evening, and to do according to all that is written in the law of the LORD, which he commanded Israel;"
        },
        {
          "verse": "41",
          "text": "And with them Heman and Jeduthun, and the rest that were chosen, who were expressed by name, to give thanks to the LORD, because his mercy endureth for ever;"
        },
        {
          "verse": "42",
          "text": "And with them Heman and Jeduthun with trumpets and cymbals for those that should make a sound, and with musical instruments of God. And the sons of Jeduthun were porters."
        },
        {
          "verse": "43",
          "text": "And all the people departed every man to his house: and David returned to bless his house."
        }
      ]
    },
    {
      "chapter": "17",
      "verses": [
        {
          "verse": "1",
          "text": "Now it came to pass, as David sat in his house, that David said to Nathan the prophet, Lo, I dwell in an house of cedars, but the ark of the covenant of the LORD remaineth under curtains."
        },
        {
          "verse": "2",
          "text": "Then Nathan said unto David, Do all that is in thine heart; for God is with thee."
        },
        {
          "verse": "3",
          "text": "And it came to pass the same night, that the word of God came to Nathan, saying,"
        },
        {
          "verse": "4",
          "text": "Go and tell David my servant, Thus saith the LORD, Thou shalt not build me an house to dwell in:"
        },
        {
          "verse": "5",
          "text": "For I have not dwelt in an house since the day that I brought up Israel unto this day; but have gone from tent to tent, and from one tabernacle to another."
        },
        {
          "verse": "6",
          "text": "Wheresoever I have walked with all Israel, spake I a word to any of the judges of Israel, whom I commanded to feed my people, saying, Why have ye not built me an house of cedars?"
        },
        {
          "verse": "7",
          "text": "Now therefore thus shalt thou say unto my servant David, Thus saith the LORD of hosts, I took thee from the sheepcote, even from following the sheep, that thou shouldest be ruler over my people Israel:"
        },
        {
          "verse": "8",
          "text": "And I have been with thee whithersoever thou hast walked, and have cut off all thine enemies from before thee, and have made thee a name like the name of the great men that are in the earth."
        },
        {
          "verse": "9",
          "text": "Also I will ordain a place for my people Israel, and will plant them, and they shall dwell in their place, and shall be moved no more; neither shall the children of wickedness waste them any more, as at the beginning,"
        },
        {
          "verse": "10",
          "text": "And since the time that I commanded judges to be over my people Israel. Moreover I will subdue all thine enemies. Furthermore I tell thee that the LORD will build thee an house."
        },
        {
          "verse": "11",
          "text": "And it shall come to pass, when thy days be expired that thou must go to be with thy fathers, that I will raise up thy seed after thee, which shall be of thy sons; and I will establish his kingdom."
        },
        {
          "verse": "12",
          "text": "He shall build me an house, and I will stablish his throne for ever."
        },
        {
          "verse": "13",
          "text": "I will be his father, and he shall be my son: and I will not take my mercy away from him, as I took it from him that was before thee:"
        },
        {
          "verse": "14",
          "text": "But I will settle him in mine house and in my kingdom for ever: and his throne shall be established for evermore."
        },
        {
          "verse": "15",
          "text": "According to all these words, and according to all this vision, so did Nathan speak unto David."
        },
        {
          "verse": "16",
          "text": "And David the king came and sat before the LORD, and said, Who am I, O LORD God, and what is mine house, that thou hast brought me hitherto?"
        },
        {
          "verse": "17",
          "text": "And yet this was a small thing in thine eyes, O God; for thou hast also spoken of thy servant\u2019s house for a great while to come, and hast regarded me according to the estate of a man of high degree, O LORD God."
        },
        {
          "verse": "18",
          "text": "What can David speak more to thee for the honour of thy servant? for thou knowest thy servant."
        },
        {
          "verse": "19",
          "text": "O LORD, for thy servant\u2019s sake, and according to thine own heart, hast thou done all this greatness, in making known all these great things."
        },
        {
          "verse": "20",
          "text": "O LORD, there is none like thee, neither is there any God beside thee, according to all that we have heard with our ears."
        },
        {
          "verse": "21",
          "text": "And what one nation in the earth is like thy people Israel, whom God went to redeem to be his own people, to make thee a name of greatness and terribleness, by driving out nations from before thy people, whom thou hast redeemed out of Egypt?"
        },
        {
          "verse": "22",
          "text": "For thy people Israel didst thou make thine own people for ever; and thou, LORD, becamest their God."
        },
        {
          "verse": "23",
          "text": "Therefore now, LORD, let the thing that thou hast spoken concerning thy servant and concerning his house be established for ever, and do as thou hast said."
        },
        {
          "verse": "24",
          "text": "Let it even be established, that thy name may be magnified for ever, saying, The LORD of hosts is the God of Israel, even a God to Israel: and let the house of David thy servant be established before thee."
        },
        {
          "verse": "25",
          "text": "For thou, O my God, hast told thy servant that thou wilt build him an house: therefore thy servant hath found in his heart to pray before thee."
        },
        {
          "verse": "26",
          "text": "And now, LORD, thou art God, and hast promised this goodness unto thy servant:"
        },
        {
          "verse": "27",
          "text": "Now therefore let it please thee to bless the house of thy servant, that it may be before thee for ever: for thou blessest, O LORD, and it shall be blessed for ever."
        }
      ]
    },
    {
      "chapter": "18",
      "verses": [
        {
          "verse": "1",
          "text": "Now after this it came to pass, that David smote the Philistines, and subdued them, and took Gath and her towns out of the hand of the Philistines."
        },
        {
          "verse": "2",
          "text": "And he smote Moab; and the Moabites became David\u2019s servants, and brought gifts."
        },
        {
          "verse": "3",
          "text": "And David smote Hadarezer king of Zobah unto Hamath, as he went to stablish his dominion by the river Euphrates."
        },
        {
          "verse": "4",
          "text": "And David took from him a thousand chariots, and seven thousand horsemen, and twenty thousand footmen: David also houghed all the chariot horses, but reserved of them an hundred chariots."
        },
        {
          "verse": "5",
          "text": "And when the Syrians of Damascus came to help Hadarezer king of Zobah, David slew of the Syrians two and twenty thousand men."
        },
        {
          "verse": "6",
          "text": "Then David put garrisons in Syriadamascus; and the Syrians became David\u2019s servants, and brought gifts. Thus the LORD preserved David whithersoever he went."
        },
        {
          "verse": "7",
          "text": "And David took the shields of gold that were on the servants of Hadarezer, and brought them to Jerusalem."
        },
        {
          "verse": "8",
          "text": "Likewise from Tibhath, and from Chun, cities of Hadarezer, brought David very much brass, wherewith Solomon made the brasen sea, and the pillars, and the vessels of brass."
        },
        {
          "verse": "9",
          "text": "Now when Tou king of Hamath heard how David had smitten all the host of Hadarezer king of Zobah;"
        },
        {
          "verse": "10",
          "text": "He sent Hadoram his son to king David, to enquire of his welfare, and to congratulate him, because he had fought against Hadarezer, and smitten him; (for Hadarezer had war with Tou;) and with him all manner of vessels of gold and silver and brass."
        },
        {
          "verse": "11",
          "text": "Them also king David dedicated unto the LORD, with the silver and the gold that he brought from all these nations; from Edom, and from Moab, and from the children of Ammon, and from the Philistines, and from Amalek."
        },
        {
          "verse": "12",
          "text": "Moreover Abishai the son of Zeruiah slew of the Edomites in the valley of salt eighteen thousand."
        },
        {
          "verse": "13",
          "text": "And he put garrisons in Edom; and all the Edomites became David\u2019s servants. Thus the LORD preserved David whithersoever he went."
        },
        {
          "verse": "14",
          "text": "So David reigned over all Israel, and executed judgment and justice among all his people."
        },
        {
          "verse": "15",
          "text": "And Joab the son of Zeruiah was over the host; and Jehoshaphat the son of Ahilud, recorder."
        },
        {
          "verse": "16",
          "text": "And Zadok the son of Ahitub, and Abimelech the son of Abiathar, were the priests; and Shavsha was scribe;"
        },
        {
          "verse": "17",
          "text": "And Benaiah the son of Jehoiada was over the Cherethites and the Pelethites; and the sons of David were chief about the king."
        }
      ]
    },
    {
      "chapter": "19",
      "verses": [
        {
          "verse": "1",
          "text": "Now it came to pass after this, that Nahash the king of the children of Ammon died, and his son reigned in his stead."
        },
        {
          "verse": "2",
          "text": "And David said, I will shew kindness unto Hanun the son of Nahash, because his father shewed kindness to me. And David sent messengers to comfort him concerning his father. So the servants of David came into the land of the children of Ammon to Hanun, to comfort him."
        },
        {
          "verse": "3",
          "text": "But the princes of the children of Ammon said to Hanun, Thinkest thou that David doth honour thy father, that he hath sent comforters unto thee? are not his servants come unto thee for to search, and to overthrow, and to spy out the land?"
        },
        {
          "verse": "4",
          "text": "Wherefore Hanun took David\u2019s servants, and shaved them, and cut off their garments in the midst hard by their buttocks, and sent them away."
        },
        {
          "verse": "5",
          "text": "Then there went certain, and told David how the men were served. And he sent to meet them: for the men were greatly ashamed. And the king said, Tarry at Jericho until your beards be grown, and then return."
        },
        {
          "verse": "6",
          "text": "And when the children of Ammon saw that they had made themselves odious to David, Hanun and the children of Ammon sent a thousand talents of silver to hire them chariots and horsemen out of Mesopotamia, and out of Syriamaachah, and out of Zobah."
        },
        {
          "verse": "7",
          "text": "So they hired thirty and two thousand chariots, and the king of Maachah and his people; who came and pitched before Medeba. And the children of Ammon gathered themselves together from their cities, and came to battle."
        },
        {
          "verse": "8",
          "text": "And when David heard of it, he sent Joab, and all the host of the mighty men."
        },
        {
          "verse": "9",
          "text": "And the children of Ammon came out, and put the battle in array before the gate of the city: and the kings that were come were by themselves in the field."
        },
        {
          "verse": "10",
          "text": "Now when Joab saw that the battle was set against him before and behind, he chose out of all the choice of Israel, and put them in array against the Syrians."
        },
        {
          "verse": "11",
          "text": "And the rest of the people he delivered unto the hand of Abishai his brother, and they set themselves in array against the children of Ammon."
        },
        {
          "verse": "12",
          "text": "And he said, If the Syrians be too strong for me, then thou shalt help me: but if the children of Ammon be too strong for thee, then I will help thee."
        },
        {
          "verse": "13",
          "text": "Be of good courage, and let us behave ourselves valiantly for our people, and for the cities of our God: and let the LORD do that which is good in his sight."
        },
        {
          "verse": "14",
          "text": "So Joab and the people that were with him drew nigh before the Syrians unto the battle; and they fled before him."
        },
        {
          "verse": "15",
          "text": "And when the children of Ammon saw that the Syrians were fled, they likewise fled before Abishai his brother, and entered into the city. Then Joab came to Jerusalem."
        },
        {
          "verse": "16",
          "text": "And when the Syrians saw that they were put to the worse before Israel, they sent messengers, and drew forth the Syrians that were beyond the river: and Shophach the captain of the host of Hadarezer went before them."
        },
        {
          "verse": "17",
          "text": "And it was told David; and he gathered all Israel, and passed over Jordan, and came upon them, and set the battle in array against them. So when David had put the battle in array against the Syrians, they fought with him."
        },
        {
          "verse": "18",
          "text": "But the Syrians fled before Israel; and David slew of the Syrians seven thousand men which fought in chariots, and forty thousand footmen, and killed Shophach the captain of the host."
        },
        {
          "verse": "19",
          "text": "And when the servants of Hadarezer saw that they were put to the worse before Israel, they made peace with David, and became his servants: neither would the Syrians help the children of Ammon any more."
        }
      ]
    },
    {
      "chapter": "20",
      "verses": [
        {
          "verse": "1",
          "text": "And it came to pass, that after the year was expired, at the time that kings go out to battle, Joab led forth the power of the army, and wasted the country of the children of Ammon, and came and besieged Rabbah. But David tarried at Jerusalem. And Joab smote Rabbah, and destroyed it."
        },
        {
          "verse": "2",
          "text": "And David took the crown of their king from off his head, and found it to weigh a talent of gold, and there were precious stones in it; and it was set upon David\u2019s head: and he brought also exceeding much spoil out of the city."
        },
        {
          "verse": "3",
          "text": "And he brought out the people that were in it, and cut them with saws, and with harrows of iron, and with axes. Even so dealt David with all the cities of the children of Ammon. And David and all the people returned to Jerusalem."
        },
        {
          "verse": "4",
          "text": "And it came to pass after this, that there arose war at Gezer with the Philistines; at which time Sibbechai the Hushathite slew Sippai, that was of the children of the giant: and they were subdued."
        },
        {
          "verse": "5",
          "text": "And there was war again with the Philistines; and Elhanan the son of Jair slew Lahmi the brother of Goliath the Gittite, whose spear staff was like a weaver\u2019s beam."
        },
        {
          "verse": "6",
          "text": "And yet again there was war at Gath, where was a man of great stature, whose fingers and toes were four and twenty, six on each hand, and six on each foot and he also was the son of the giant."
        },
        {
          "verse": "7",
          "text": "But when he defied Israel, Jonathan the son of Shimea David\u2019s brother slew him."
        },
        {
          "verse": "8",
          "text": "These were born unto the giant in Gath; and they fell by the hand of David, and by the hand of his servants."
        }
      ]
    },
    {
      "chapter": "21",
      "verses": [
        {
          "verse": "1",
          "text": "And Satan stood up against Israel, and provoked David to number Israel."
        },
        {
          "verse": "2",
          "text": "And David said to Joab and to the rulers of the people, Go, number Israel from Beersheba even to Dan; and bring the number of them to me, that I may know it."
        },
        {
          "verse": "3",
          "text": "And Joab answered, The LORD make his people an hundred times so many more as they be: but, my lord the king, are they not all my lord\u2019s servants? why then doth my lord require this thing? why will he be a cause of trespass to Israel?"
        },
        {
          "verse": "4",
          "text": "Nevertheless the king\u2019s word prevailed against Joab. Wherefore Joab departed, and went throughout all Israel, and came to Jerusalem."
        },
        {
          "verse": "5",
          "text": "And Joab gave the sum of the number of the people unto David. And all they of Israel were a thousand thousand and an hundred thousand men that drew sword: and Judah was four hundred threescore and ten thousand men that drew sword."
        },
        {
          "verse": "6",
          "text": "But Levi and Benjamin counted he not among them: for the king\u2019s word was abominable to Joab."
        },
        {
          "verse": "7",
          "text": "And God was displeased with this thing; therefore he smote Israel."
        },
        {
          "verse": "8",
          "text": "And David said unto God, I have sinned greatly, because I have done this thing: but now, I beseech thee, do away the iniquity of thy servant; for I have done very foolishly."
        },
        {
          "verse": "9",
          "text": "And the LORD spake unto Gad, David\u2019s seer, saying,"
        },
        {
          "verse": "10",
          "text": "Go and tell David, saying, Thus saith the LORD, I offer thee three things: choose thee one of them, that I may do it unto thee."
        },
        {
          "verse": "11",
          "text": "So Gad came to David, and said unto him, Thus saith the LORD, Choose thee"
        },
        {
          "verse": "12",
          "text": "Either three years\u2019 famine; or three months to be destroyed before thy foes, while that the sword of thine enemies overtaketh thee; or else three days the sword of the LORD, even the pestilence, in the land, and the angel of the LORD destroying throughout all the coasts of Israel. Now therefore advise thyself what word I shall bring again to him that sent me."
        },
        {
          "verse": "13",
          "text": "And David said unto Gad, I am in a great strait: let me fall now into the hand of the LORD; for very great are his mercies: but let me not fall into the hand of man."
        },
        {
          "verse": "14",
          "text": "So the LORD sent pestilence upon Israel: and there fell of Israel seventy thousand men."
        },
        {
          "verse": "15",
          "text": "And God sent an angel unto Jerusalem to destroy it: and as he was destroying, the LORD beheld, and he repented him of the evil, and said to the angel that destroyed, It is enough, stay now thine hand. And the angel of the LORD stood by the threshingfloor of Ornan the Jebusite."
        },
        {
          "verse": "16",
          "text": "And David lifted up his eyes, and saw the angel of the LORD stand between the earth and the heaven, having a drawn sword in his hand stretched out over Jerusalem. Then David and the elders of Israel, who were clothed in sackcloth, fell upon their faces."
        },
        {
          "verse": "17",
          "text": "And David said unto God, Is it not I that commanded the people to be numbered? even I it is that have sinned and done evil indeed; but as for these sheep, what have they done? let thine hand, I pray thee, O LORD my God, be on me, and on my father\u2019s house; but not on thy people, that they should be plagued."
        },
        {
          "verse": "18",
          "text": "Then the angel of the LORD commanded Gad to say to David, that David should go up, and set up an altar unto the LORD in the threshingfloor of Ornan the Jebusite."
        },
        {
          "verse": "19",
          "text": "And David went up at the saying of Gad, which he spake in the name of the LORD."
        },
        {
          "verse": "20",
          "text": "And Ornan turned back, and saw the angel; and his four sons with him hid themselves. Now Ornan was threshing wheat."
        },
        {
          "verse": "21",
          "text": "And as David came to Ornan, Ornan looked and saw David, and went out of the threshingfloor, and bowed himself to David with his face to the ground."
        },
        {
          "verse": "22",
          "text": "Then David said to Ornan, Grant me the place of this threshingfloor, that I may build an altar therein unto the LORD: thou shalt grant it me for the full price: that the plague may be stayed from the people."
        },
        {
          "verse": "23",
          "text": "And Ornan said unto David, Take it to thee, and let my lord the king do that which is good in his eyes: lo, I give thee the oxen also for burnt offerings, and the threshing instruments for wood, and the wheat for the meat offering; I give it all."
        },
        {
          "verse": "24",
          "text": "And king David said to Ornan, Nay; but I will verily buy it for the full price: for I will not take that which is thine for the LORD, nor offer burnt offerings without cost."
        },
        {
          "verse": "25",
          "text": "So David gave to Ornan for the place six hundred shekels of gold by weight."
        },
        {
          "verse": "26",
          "text": "And David built there an altar unto the LORD, and offered burnt offerings and peace offerings, and called upon the LORD; and he answered him from heaven by fire upon the altar of burnt offering."
        },
        {
          "verse": "27",
          "text": "And the LORD commanded the angel; and he put up his sword again into the sheath thereof."
        },
        {
          "verse": "28",
          "text": "At that time when David saw that the LORD had answered him in the threshingfloor of Ornan the Jebusite, then he sacrificed there."
        },
        {
          "verse": "29",
          "text": "For the tabernacle of the LORD, which Moses made in the wilderness, and the altar of the burnt offering, were at that season in the high place at Gibeon."
        },
        {
          "verse": "30",
          "text": "But David could not go before it to enquire of God: for he was afraid because of the sword of the angel of the LORD."
        }
      ]
    },
    {
      "chapter": "22",
      "verses": [
        {
          "verse": "1",
          "text": "Then David said, This is the house of the LORD God, and this is the altar of the burnt offering for Israel."
        },
        {
          "verse": "2",
          "text": "And David commanded to gather together the strangers that were in the land of Israel; and he set masons to hew wrought stones to build the house of God."
        },
        {
          "verse": "3",
          "text": "And David prepared iron in abundance for the nails for the doors of the gates, and for the joinings; and brass in abundance without weight;"
        },
        {
          "verse": "4",
          "text": "Also cedar trees in abundance: for the Zidonians and they of Tyre brought much cedar wood to David."
        },
        {
          "verse": "5",
          "text": "And David said, Solomon my son is young and tender, and the house that is to be builded for the LORD must be exceeding magnifical, of fame and of glory throughout all countries: I will therefore now make preparation for it. So David prepared abundantly before his death."
        },
        {
          "verse": "6",
          "text": "Then he called for Solomon his son, and charged him to build an house for the LORD God of Israel."
        },
        {
          "verse": "7",
          "text": "And David said to Solomon, My son, as for me, it was in my mind to build an house unto the name of the LORD my God:"
        },
        {
          "verse": "8",
          "text": "But the word of the LORD came to me, saying, Thou hast shed blood abundantly, and hast made great wars: thou shalt not build an house unto my name, because thou hast shed much blood upon the earth in my sight."
        },
        {
          "verse": "9",
          "text": "Behold, a son shall be born to thee, who shall be a man of rest; and I will give him rest from all his enemies round about: for his name shall be Solomon, and I will give peace and quietness unto Israel in his days."
        },
        {
          "verse": "10",
          "text": "He shall build an house for my name; and he shall be my son, and I will be his father; and I will establish the throne of his kingdom over Israel for ever."
        },
        {
          "verse": "11",
          "text": "Now, my son, the LORD be with thee; and prosper thou, and build the house of the LORD thy God, as he hath said of thee."
        },
        {
          "verse": "12",
          "text": "Only the LORD give thee wisdom and understanding, and give thee charge concerning Israel, that thou mayest keep the law of the LORD thy God."
        },
        {
          "verse": "13",
          "text": "Then shalt thou prosper, if thou takest heed to fulfil the statutes and judgments which the LORD charged Moses with concerning Israel: be strong, and of good courage; dread not, nor be dismayed."
        },
        {
          "verse": "14",
          "text": "Now, behold, in my trouble I have prepared for the house of the LORD an hundred thousand talents of gold, and a thousand thousand talents of silver; and of brass and iron without weight; for it is in abundance: timber also and stone have I prepared; and thou mayest add thereto."
        },
        {
          "verse": "15",
          "text": "Moreover there are workmen with thee in abundance, hewers and workers of stone and timber, and all manner of cunning men for every manner of work."
        },
        {
          "verse": "16",
          "text": "Of the gold, the silver, and the brass, and the iron, there is no number. Arise therefore, and be doing, and the LORD be with thee."
        },
        {
          "verse": "17",
          "text": "David also commanded all the princes of Israel to help Solomon his son, saying,"
        },
        {
          "verse": "18",
          "text": "Is not the LORD your God with you? and hath he not given you rest on every side? for he hath given the inhabitants of the land into mine hand; and the land is subdued before the LORD, and before his people."
        },
        {
          "verse": "19",
          "text": "Now set your heart and your soul to seek the LORD your God; arise therefore, and build ye the sanctuary of the LORD God, to bring the ark of the covenant of the LORD, and the holy vessels of God, into the house that is to be built to the name of the LORD."
        }
      ]
    },
    {
      "chapter": "23",
      "verses": [
        {
          "verse": "1",
          "text": "So when David was old and full of days, he made Solomon his son king over Israel."
        },
        {
          "verse": "2",
          "text": "And he gathered together all the princes of Israel, with the priests and the Levites."
        },
        {
          "verse": "3",
          "text": "Now the Levites were numbered from the age of thirty years and upward: and their number by their polls, man by man, was thirty and eight thousand."
        },
        {
          "verse": "4",
          "text": "Of which, twenty and four thousand were to set forward the work of the house of the LORD; and six thousand were officers and judges:"
        },
        {
          "verse": "5",
          "text": "Moreover four thousand were porters; and four thousand praised the LORD with the instruments which I made, said David, to praise therewith."
        },
        {
          "verse": "6",
          "text": "And David divided them into courses among the sons of Levi, namely, Gershon, Kohath, and Merari."
        },
        {
          "verse": "7",
          "text": "Of the Gershonites were, Laadan, and Shimei."
        },
        {
          "verse": "8",
          "text": "The sons of Laadan; the chief was Jehiel, and Zetham, and Joel, three."
        },
        {
          "verse": "9",
          "text": "The sons of Shimei; Shelomith, and Haziel, and Haran, three. These were the chief of the fathers of Laadan."
        },
        {
          "verse": "10",
          "text": "And the sons of Shimei were, Jahath, Zina, and Jeush, and Beriah. These four were the sons of Shimei."
        },
        {
          "verse": "11",
          "text": "And Jahath was the chief, and Zizah the second: but Jeush and Beriah had not many sons; therefore they were in one reckoning, according to their father\u2019s house."
        },
        {
          "verse": "12",
          "text": "The sons of Kohath; Amram, Izhar, Hebron, and Uzziel, four."
        },
        {
          "verse": "13",
          "text": "The sons of Amram; Aaron and Moses: and Aaron was separated, that he should sanctify the most holy things, he and his sons for ever, to burn incense before the LORD, to minister unto him, and to bless in his name for ever."
        },
        {
          "verse": "14",
          "text": "Now concerning Moses the man of God, his sons were named of the tribe of Levi."
        },
        {
          "verse": "15",
          "text": "The sons of Moses were, Gershom, and Eliezer."
        },
        {
          "verse": "16",
          "text": "Of the sons of Gershom, Shebuel was the chief."
        },
        {
          "verse": "17",
          "text": "And the sons of Eliezer were, Rehabiah the chief. And Eliezer had none other sons; but the sons of Rehabiah were very many."
        },
        { "verse": "18", "text": "Of the sons of Izhar; Shelomith the chief." },
        {
          "verse": "19",
          "text": "Of the sons of Hebron; Jeriah the first, Amariah the second, Jahaziel the third, and Jekameam the fourth."
        },
        {
          "verse": "20",
          "text": "Of the sons of Uzziel; Micah the first, and Jesiah the second."
        },
        {
          "verse": "21",
          "text": "The sons of Merari; Mahli, and Mushi. The sons of Mahli; Eleazar, and Kish."
        },
        {
          "verse": "22",
          "text": "And Eleazar died, and had no sons, but daughters: and their brethren the sons of Kish took them."
        },
        {
          "verse": "23",
          "text": "The sons of Mushi; Mahli, and Eder, and Jeremoth, three."
        },
        {
          "verse": "24",
          "text": "These were the sons of Levi after the house of their fathers; even the chief of the fathers, as they were counted by number of names by their polls, that did the work for the service of the house of the LORD, from the age of twenty years and upward."
        },
        {
          "verse": "25",
          "text": "For David said, The LORD God of Israel hath given rest unto his people, that they may dwell in Jerusalem for ever:"
        },
        {
          "verse": "26",
          "text": "And also unto the Levites; they shall no more carry the tabernacle, nor any vessels of it for the service thereof."
        },
        {
          "verse": "27",
          "text": "For by the last words of David the Levites were numbered from twenty years old and above:"
        },
        {
          "verse": "28",
          "text": "Because their office was to wait on the sons of Aaron for the service of the house of the LORD, in the courts, and in the chambers, and in the purifying of all holy things, and the work of the service of the house of God;"
        },
        {
          "verse": "29",
          "text": "Both for the shewbread, and for the fine flour for meat offering, and for the unleavened cakes, and for that which is baked in the pan, and for that which is fried, and for all manner of measure and size;"
        },
        {
          "verse": "30",
          "text": "And to stand every morning to thank and praise the LORD, and likewise at even;"
        },
        {
          "verse": "31",
          "text": "And to offer all burnt sacrifices unto the LORD in the sabbaths, in the new moons, and on the set feasts, by number, according to the order commanded unto them, continually before the LORD:"
        },
        {
          "verse": "32",
          "text": "And that they should keep the charge of the tabernacle of the congregation, and the charge of the holy place, and the charge of the sons of Aaron their brethren, in the service of the house of the LORD."
        }
      ]
    },
    {
      "chapter": "24",
      "verses": [
        {
          "verse": "1",
          "text": "Now these are the divisions of the sons of Aaron. The sons of Aaron; Nadab, and Abihu, Eleazar, and Ithamar."
        },
        {
          "verse": "2",
          "text": "But Nadab and Abihu died before their father, and had no children: therefore Eleazar and Ithamar executed the priest\u2019s office."
        },
        {
          "verse": "3",
          "text": "And David distributed them, both Zadok of the sons of Eleazar, and Ahimelech of the sons of Ithamar, according to their offices in their service."
        },
        {
          "verse": "4",
          "text": "And there were more chief men found of the sons of Eleazar than of the sons of Ithamar; and thus were they divided. Among the sons of Eleazar there were sixteen chief men of the house of their fathers, and eight among the sons of Ithamar according to the house of their fathers."
        },
        {
          "verse": "5",
          "text": "Thus were they divided by lot, one sort with another; for the governors of the sanctuary, and governors of the house of God, were of the sons of Eleazar, and of the sons of Ithamar."
        },
        {
          "verse": "6",
          "text": "And Shemaiah the son of Nethaneel the scribe, one of the Levites, wrote them before the king, and the princes, and Zadok the priest, and Ahimelech the son of Abiathar, and before the chief of the fathers of the priests and Levites: one principal household being taken for Eleazar, and one taken for Ithamar."
        },
        {
          "verse": "7",
          "text": "Now the first lot came forth to Jehoiarib, the second to Jedaiah,"
        },
        { "verse": "8", "text": "The third to Harim, the fourth to Seorim," },
        {
          "verse": "9",
          "text": "The fifth to Malchijah, the sixth to Mijamin,"
        },
        {
          "verse": "10",
          "text": "The seventh to Hakkoz, the eighth to Abijah,"
        },
        {
          "verse": "11",
          "text": "The ninth to Jeshuah, the tenth to Shecaniah,"
        },
        {
          "verse": "12",
          "text": "The eleventh to Eliashib, the twelfth to Jakim,"
        },
        {
          "verse": "13",
          "text": "The thirteenth to Huppah, the fourteenth to Jeshebeab,"
        },
        {
          "verse": "14",
          "text": "The fifteenth to Bilgah, the sixteenth to Immer,"
        },
        {
          "verse": "15",
          "text": "The seventeenth to Hezir, the eighteenth to Aphses,"
        },
        {
          "verse": "16",
          "text": "The nineteenth to Pethahiah, the twentieth to Jehezekel,"
        },
        {
          "verse": "17",
          "text": "The one and twentieth to Jachin, the two and twentieth to Gamul,"
        },
        {
          "verse": "18",
          "text": "The three and twentieth to Delaiah, the four and twentieth to Maaziah."
        },
        {
          "verse": "19",
          "text": "These were the orderings of them in their service to come into the house of the LORD, according to their manner, under Aaron their father, as the LORD God of Israel had commanded him."
        },
        {
          "verse": "20",
          "text": "And the rest of the sons of Levi were these: Of the sons of Amram; Shubael: of the sons of Shubael; Jehdeiah."
        },
        {
          "verse": "21",
          "text": "Concerning Rehabiah: of the sons of Rehabiah, the first was Isshiah."
        },
        {
          "verse": "22",
          "text": "Of the Izharites; Shelomoth: of the sons of Shelomoth; Jahath."
        },
        {
          "verse": "23",
          "text": "And the sons of Hebron; Jeriah the first, Amariah the second, Jahaziel the third, Jekameam the fourth."
        },
        {
          "verse": "24",
          "text": "Of the sons of Uzziel; Michah: of the sons of Michah; Shamir."
        },
        {
          "verse": "25",
          "text": "The brother of Michah was Isshiah: of the sons of Isshiah; Zechariah."
        },
        {
          "verse": "26",
          "text": "The sons of Merari were Mahli and Mushi: the sons of Jaaziah; Beno."
        },
        {
          "verse": "27",
          "text": "The sons of Merari by Jaaziah; Beno, and Shoham, and Zaccur, and Ibri."
        },
        { "verse": "28", "text": "Of Mahli came Eleazar, who had no sons." },
        {
          "verse": "29",
          "text": "Concerning Kish: the son of Kish was Jerahmeel."
        },
        {
          "verse": "30",
          "text": "The sons also of Mushi; Mahli, and Eder, and Jerimoth. These were the sons of the Levites after the house of their fathers."
        },
        {
          "verse": "31",
          "text": "These likewise cast lots over against their brethren the sons of Aaron in the presence of David the king, and Zadok, and Ahimelech, and the chief of the fathers of the priests and Levites, even the principal fathers over against their younger brethren."
        }
      ]
    },
    {
      "chapter": "25",
      "verses": [
        {
          "verse": "1",
          "text": "Moreover David and the captains of the host separated to the service of the sons of Asaph, and of Heman, and of Jeduthun, who should prophesy with harps, with psalteries, and with cymbals: and the number of the workmen according to their service was:"
        },
        {
          "verse": "2",
          "text": "Of the sons of Asaph; Zaccur, and Joseph, and Nethaniah, and Asarelah, the sons of Asaph under the hands of Asaph, which prophesied according to the order of the king."
        },
        {
          "verse": "3",
          "text": "Of Jeduthun: the sons of Jeduthun; Gedaliah, and Zeri, and Jeshaiah, Hashabiah, and Mattithiah, six, under the hands of their father Jeduthun, who prophesied with a harp, to give thanks and to praise the LORD."
        },
        {
          "verse": "4",
          "text": "Of Heman: the sons of Heman: Bukkiah, Mattaniah, Uzziel, Shebuel, and Jerimoth, Hananiah, Hanani, Eliathah, Giddalti, and Romamtiezer, Joshbekashah, Mallothi, Hothir, and Mahazioth:"
        },
        {
          "verse": "5",
          "text": "All these were the sons of Heman the king\u2019s seer in the words of God, to lift up the horn. And God gave to Heman fourteen sons and three daughters."
        },
        {
          "verse": "6",
          "text": "All these were under the hands of their father for song in the house of the LORD, with cymbals, psalteries, and harps, for the service of the house of God, according to the king\u2019s order to Asaph, Jeduthun, and Heman."
        },
        {
          "verse": "7",
          "text": "So the number of them, with their brethren that were instructed in the songs of the LORD, even all that were cunning, was two hundred fourscore and eight."
        },
        {
          "verse": "8",
          "text": "And they cast lots, ward against ward, as well the small as the great, the teacher as the scholar."
        },
        {
          "verse": "9",
          "text": "Now the first lot came forth for Asaph to Joseph: the second to Gedaliah, who with his brethren and sons were twelve:"
        },
        {
          "verse": "10",
          "text": "The third to Zaccur, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "11",
          "text": "The fourth to Izri, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "12",
          "text": "The fifth to Nethaniah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "13",
          "text": "The sixth to Bukkiah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "14",
          "text": "The seventh to Jesharelah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "15",
          "text": "The eighth to Jeshaiah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "16",
          "text": "The ninth to Mattaniah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "17",
          "text": "The tenth to Shimei, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "18",
          "text": "The eleventh to Azareel, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "19",
          "text": "The twelfth to Hashabiah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "20",
          "text": "The thirteenth to Shubael, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "21",
          "text": "The fourteenth to Mattithiah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "22",
          "text": "The fifteenth to Jeremoth, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "23",
          "text": "The sixteenth to Hananiah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "24",
          "text": "The seventeenth to Joshbekashah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "25",
          "text": "The eighteenth to Hanani, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "26",
          "text": "The nineteenth to Mallothi, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "27",
          "text": "The twentieth to Eliathah, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "28",
          "text": "The one and twentieth to Hothir, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "29",
          "text": "The two and twentieth to Giddalti, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "30",
          "text": "The three and twentieth to Mahazioth, he, his sons, and his brethren, were twelve:"
        },
        {
          "verse": "31",
          "text": "The four and twentieth to Romamtiezer, he, his sons, and his brethren, were twelve."
        }
      ]
    },
    {
      "chapter": "26",
      "verses": [
        {
          "verse": "1",
          "text": "Concerning the divisions of the porters: Of the Korhites was Meshelemiah the son of Kore, of the sons of Asaph."
        },
        {
          "verse": "2",
          "text": "And the sons of Meshelemiah were, Zechariah the firstborn, Jediael the second, Zebadiah the third, Jathniel the fourth,"
        },
        {
          "verse": "3",
          "text": "Elam the fifth, Jehohanan the sixth, Elioenai the seventh."
        },
        {
          "verse": "4",
          "text": "Moreover the sons of Obededom were, Shemaiah the firstborn, Jehozabad the second, Joah the third, and Sacar the fourth, and Nethaneel the fifth,"
        },
        {
          "verse": "5",
          "text": "Ammiel the sixth, Issachar the seventh, Peulthai the eighth: for God blessed him."
        },
        {
          "verse": "6",
          "text": "Also unto Shemaiah his son were sons born, that ruled throughout the house of their father: for they were mighty men of valour."
        },
        {
          "verse": "7",
          "text": "The sons of Shemaiah; Othni, and Rephael, and Obed, Elzabad, whose brethren were strong men, Elihu, and Semachiah."
        },
        {
          "verse": "8",
          "text": "All these of the sons of Obededom: they and their sons and their brethren, able men for strength for the service, were threescore and two of Obededom."
        },
        {
          "verse": "9",
          "text": "And Meshelemiah had sons and brethren, strong men, eighteen."
        },
        {
          "verse": "10",
          "text": "Also Hosah, of the children of Merari, had sons; Simri the chief, (for though he was not the firstborn, yet his father made him the chief;)"
        },
        {
          "verse": "11",
          "text": "Hilkiah the second, Tebaliah the third, Zechariah the fourth: all the sons and brethren of Hosah were thirteen."
        },
        {
          "verse": "12",
          "text": "Among these were the divisions of the porters, even among the chief men, having wards one against another, to minister in the house of the LORD."
        },
        {
          "verse": "13",
          "text": "And they cast lots, as well the small as the great, according to the house of their fathers, for every gate."
        },
        {
          "verse": "14",
          "text": "And the lot eastward fell to Shelemiah. Then for Zechariah his son, a wise counsellor, they cast lots; and his lot came out northward."
        },
        {
          "verse": "15",
          "text": "To Obededom southward; and to his sons the house of Asuppim."
        },
        {
          "verse": "16",
          "text": "To Shuppim and Hosah the lot came forth westward, with the gate Shallecheth, by the causeway of the going up, ward against ward."
        },
        {
          "verse": "17",
          "text": "Eastward were six Levites, northward four a day, southward four a day, and toward Asuppim two and two."
        },
        {
          "verse": "18",
          "text": "At Parbar westward, four at the causeway, and two at Parbar."
        },
        {
          "verse": "19",
          "text": "These are the divisions of the porters among the sons of Kore, and among the sons of Merari."
        },
        {
          "verse": "20",
          "text": "And of the Levites, Ahijah was over the treasures of the house of God, and over the treasures of the dedicated things."
        },
        {
          "verse": "21",
          "text": "As concerning the sons of Laadan; the sons of the Gershonite Laadan, chief fathers, even of Laadan the Gershonite, were Jehieli."
        },
        {
          "verse": "22",
          "text": "The sons of Jehieli; Zetham, and Joel his brother, which were over the treasures of the house of the LORD."
        },
        {
          "verse": "23",
          "text": "Of the Amramites, and the Izharites, the Hebronites, and the Uzzielites:"
        },
        {
          "verse": "24",
          "text": "And Shebuel the son of Gershom, the son of Moses, was ruler of the treasures."
        },
        {
          "verse": "25",
          "text": "And his brethren by Eliezer; Rehabiah his son, and Jeshaiah his son, and Joram his son, and Zichri his son, and Shelomith his son."
        },
        {
          "verse": "26",
          "text": "Which Shelomith and his brethren were over all the treasures of the dedicated things, which David the king, and the chief fathers, the captains over thousands and hundreds, and the captains of the host, had dedicated."
        },
        {
          "verse": "27",
          "text": "Out of the spoils won in battles did they dedicate to maintain the house of the LORD."
        },
        {
          "verse": "28",
          "text": "And all that Samuel the seer, and Saul the son of Kish, and Abner the son of Ner, and Joab the son of Zeruiah, had dedicated; and whosoever had dedicated any thing, it was under the hand of Shelomith, and of his brethren."
        },
        {
          "verse": "29",
          "text": "Of the Izharites, Chenaniah and his sons were for the outward business over Israel, for officers and judges."
        },
        {
          "verse": "30",
          "text": "And of the Hebronites, Hashabiah and his brethren, men of valour, a thousand and seven hundred, were officers among them of Israel on this side Jordan westward in all the business of the LORD, and in the service of the king."
        },
        {
          "verse": "31",
          "text": "Among the Hebronites was Jerijah the chief, even among the Hebronites, according to the generations of his fathers. In the fortieth year of the reign of David they were sought for, and there were found among them mighty men of valour at Jazer of Gilead."
        },
        {
          "verse": "32",
          "text": "And his brethren, men of valour, were two thousand and seven hundred chief fathers, whom king David made rulers over the Reubenites, the Gadites, and the half tribe of Manasseh, for every matter pertaining to God, and affairs of the king."
        }
      ]
    },
    {
      "chapter": "27",
      "verses": [
        {
          "verse": "1",
          "text": "Now the children of Israel after their number, to wit, the chief fathers and captains of thousands and hundreds, and their officers that served the king in any matter of the courses, which came in and went out month by month throughout all the months of the year, of every course were twenty and four thousand."
        },
        {
          "verse": "2",
          "text": "Over the first course for the first month was Jashobeam the son of Zabdiel: and in his course were twenty and four thousand."
        },
        {
          "verse": "3",
          "text": "Of the children of Perez was the chief of all the captains of the host for the first month."
        },
        {
          "verse": "4",
          "text": "And over the course of the second month was Dodai an Ahohite, and of his course was Mikloth also the ruler: in his course likewise were twenty and four thousand."
        },
        {
          "verse": "5",
          "text": "The third captain of the host for the third month was Benaiah the son of Jehoiada, a chief priest: and in his course were twenty and four thousand."
        },
        {
          "verse": "6",
          "text": "This is that Benaiah, who was mighty among the thirty, and above the thirty: and in his course was Ammizabad his son."
        },
        {
          "verse": "7",
          "text": "The fourth captain for the fourth month was Asahel the brother of Joab, and Zebadiah his son after him: and in his course were twenty and four thousand."
        },
        {
          "verse": "8",
          "text": "The fifth captain for the fifth month was Shamhuth the Izrahite: and in his course were twenty and four thousand."
        },
        {
          "verse": "9",
          "text": "The sixth captain for the sixth month was Ira the son of Ikkesh the Tekoite: and in his course were twenty and four thousand."
        },
        {
          "verse": "10",
          "text": "The seventh captain for the seventh month was Helez the Pelonite, of the children of Ephraim: and in his course were twenty and four thousand."
        },
        {
          "verse": "11",
          "text": "The eighth captain for the eighth month was Sibbecai the Hushathite, of the Zarhites: and in his course were twenty and four thousand."
        },
        {
          "verse": "12",
          "text": "The ninth captain for the ninth month was Abiezer the Anetothite, of the Benjamites: and in his course were twenty and four thousand."
        },
        {
          "verse": "13",
          "text": "The tenth captain for the tenth month was Maharai the Netophathite, of the Zarhites: and in his course were twenty and four thousand."
        },
        {
          "verse": "14",
          "text": "The eleventh captain for the eleventh month was Benaiah the Pirathonite, of the children of Ephraim: and in his course were twenty and four thousand."
        },
        {
          "verse": "15",
          "text": "The twelfth captain for the twelfth month was Heldai the Netophathite, of Othniel: and in his course were twenty and four thousand."
        },
        {
          "verse": "16",
          "text": "Furthermore over the tribes of Israel: the ruler of the Reubenites was Eliezer the son of Zichri: of the Simeonites, Shephatiah the son of Maachah:"
        },
        {
          "verse": "17",
          "text": "Of the Levites, Hashabiah the son of Kemuel: of the Aaronites, Zadok:"
        },
        {
          "verse": "18",
          "text": "Of Judah, Elihu, one of the brethren of David: of Issachar, Omri the son of Michael:"
        },
        {
          "verse": "19",
          "text": "Of Zebulun, Ishmaiah the son of Obadiah: of Naphtali, Jerimoth the son of Azriel:"
        },
        {
          "verse": "20",
          "text": "Of the children of Ephraim, Hoshea the son of Azaziah: of the half tribe of Manasseh, Joel the son of Pedaiah:"
        },
        {
          "verse": "21",
          "text": "Of the half tribe of Manasseh in Gilead, Iddo the son of Zechariah: of Benjamin, Jaasiel the son of Abner:"
        },
        {
          "verse": "22",
          "text": "Of Dan, Azareel the son of Jeroham. These were the princes of the tribes of Israel."
        },
        {
          "verse": "23",
          "text": "But David took not the number of them from twenty years old and under: because the LORD had said he would increase Israel like to the stars of the heavens."
        },
        {
          "verse": "24",
          "text": "Joab the son of Zeruiah began to number, but he finished not, because there fell wrath for it against Israel; neither was the number put in the account of the chronicles of king David."
        },
        {
          "verse": "25",
          "text": "And over the king\u2019s treasures was Azmaveth the son of Adiel: and over the storehouses in the fields, in the cities, and in the villages, and in the castles, was Jehonathan the son of Uzziah:"
        },
        {
          "verse": "26",
          "text": "And over them that did the work of the field for tillage of the ground was Ezri the son of Chelub:"
        },
        {
          "verse": "27",
          "text": "And over the vineyards was Shimei the Ramathite: over the increase of the vineyards for the wine cellars was Zabdi the Shiphmite:"
        },
        {
          "verse": "28",
          "text": "And over the olive trees and the sycomore trees that were in the low plains was Baalhanan the Gederite: and over the cellars of oil was Joash:"
        },
        {
          "verse": "29",
          "text": "And over the herds that fed in Sharon was Shitrai the Sharonite: and over the herds that were in the valleys was Shaphat the son of Adlai:"
        },
        {
          "verse": "30",
          "text": "Over the camels also was Obil the Ishmaelite: and over the asses was Jehdeiah the Meronothite:"
        },
        {
          "verse": "31",
          "text": "And over the flocks was Jaziz the Hagerite. All these were the rulers of the substance which was king David\u2019s."
        },
        {
          "verse": "32",
          "text": "Also Jonathan David\u2019s uncle was a counsellor, a wise man, and a scribe: and Jehiel the son of Hachmoni was with the king\u2019s sons:"
        },
        {
          "verse": "33",
          "text": "And Ahithophel was the king\u2019s counsellor: and Hushai the Archite was the king\u2019s companion:"
        },
        {
          "verse": "34",
          "text": "And after Ahithophel was Jehoiada the son of Benaiah, and Abiathar: and the general of the king\u2019s army was Joab."
        }
      ]
    },
    {
      "chapter": "28",
      "verses": [
        {
          "verse": "1",
          "text": "And David assembled all the princes of Israel, the princes of the tribes, and the captains of the companies that ministered to the king by course, and the captains over the thousands, and captains over the hundreds, and the stewards over all the substance and possession of the king, and of his sons, with the officers, and with the mighty men, and with all the valiant men, unto Jerusalem."
        },
        {
          "verse": "2",
          "text": "Then David the king stood up upon his feet, and said, Hear me, my brethren, and my people: As for me, I had in mine heart to build an house of rest for the ark of the covenant of the LORD, and for the footstool of our God, and had made ready for the building:"
        },
        {
          "verse": "3",
          "text": "But God said unto me, Thou shalt not build an house for my name, because thou hast been a man of war, and hast shed blood."
        },
        {
          "verse": "4",
          "text": "Howbeit the LORD God of Israel chose me before all the house of my father to be king over Israel for ever: for he hath chosen Judah to be the ruler; and of the house of Judah, the house of my father; and among the sons of my father he liked me to make me king over all Israel:"
        },
        {
          "verse": "5",
          "text": "And of all my sons, (for the LORD hath given me many sons,) he hath chosen Solomon my son to sit upon the throne of the kingdom of the LORD over Israel."
        },
        {
          "verse": "6",
          "text": "And he said unto me, Solomon thy son, he shall build my house and my courts: for I have chosen him to be my son, and I will be his father."
        },
        {
          "verse": "7",
          "text": "Moreover I will establish his kingdom for ever, if he be constant to do my commandments and my judgments, as at this day."
        },
        {
          "verse": "8",
          "text": "Now therefore in the sight of all Israel the congregation of the LORD, and in the audience of our God, keep and seek for all the commandments of the LORD your God: that ye may possess this good land, and leave it for an inheritance for your children after you for ever."
        },
        {
          "verse": "9",
          "text": "And thou, Solomon my son, know thou the God of thy father, and serve him with a perfect heart and with a willing mind: for the LORD searcheth all hearts, and understandeth all the imaginations of the thoughts: if thou seek him, he will be found of thee; but if thou forsake him, he will cast thee off for ever."
        },
        {
          "verse": "10",
          "text": "Take heed now; for the LORD hath chosen thee to build an house for the sanctuary: be strong, and do it."
        },
        {
          "verse": "11",
          "text": "Then David gave to Solomon his son the pattern of the porch, and of the houses thereof, and of the treasuries thereof, and of the upper chambers thereof, and of the inner parlours thereof, and of the place of the mercy seat,"
        },
        {
          "verse": "12",
          "text": "And the pattern of all that he had by the spirit, of the courts of the house of the LORD, and of all the chambers round about, of the treasuries of the house of God, and of the treasuries of the dedicated things:"
        },
        {
          "verse": "13",
          "text": "Also for the courses of the priests and the Levites, and for all the work of the service of the house of the LORD, and for all the vessels of service in the house of the LORD."
        },
        {
          "verse": "14",
          "text": "He gave of gold by weight for things of gold, for all instruments of all manner of service; silver also for all instruments of silver by weight, for all instruments of every kind of service:"
        },
        {
          "verse": "15",
          "text": "Even the weight for the candlesticks of gold, and for their lamps of gold, by weight for every candlestick, and for the lamps thereof: and for the candlesticks of silver by weight, both for the candlestick, and also for the lamps thereof, according to the use of every candlestick."
        },
        {
          "verse": "16",
          "text": "And by weight he gave gold for the tables of shewbread, for every table; and likewise silver for the tables of silver:"
        },
        {
          "verse": "17",
          "text": "Also pure gold for the fleshhooks, and the bowls, and the cups: and for the golden basons he gave gold by weight for every bason; and likewise silver by weight for every bason of silver:"
        },
        {
          "verse": "18",
          "text": "And for the altar of incense refined gold by weight; and gold for the pattern of the chariot of the cherubims, that spread out their wings, and covered the ark of the covenant of the LORD."
        },
        {
          "verse": "19",
          "text": "All this, said David, the LORD made me understand in writing by his hand upon me, even all the works of this pattern."
        },
        {
          "verse": "20",
          "text": "And David said to Solomon his son, Be strong and of good courage, and do it: fear not, nor be dismayed: for the LORD God, even my God, will be with thee; he will not fail thee, nor forsake thee, until thou hast finished all the work for the service of the house of the LORD."
        },
        {
          "verse": "21",
          "text": "And, behold, the courses of the priests and the Levites, even they shall be with thee for all the service of the house of God: and there shall be with thee for all manner of workmanship every willing skilful man, for any manner of service: also the princes and all the people will be wholly at thy commandment."
        }
      ]
    },
    {
      "chapter": "29",
      "verses": [
        {
          "verse": "1",
          "text": "Furthermore David the king said unto all the congregation, Solomon my son, whom alone God hath chosen, is yet young and tender, and the work is great: for the palace is not for man, but for the LORD God."
        },
        {
          "verse": "2",
          "text": "Now I have prepared with all my might for the house of my God the gold for things to be made of gold, and the silver for things of silver, and the brass for things of brass, the iron for things of iron, and wood for things of wood; onyx stones, and stones to be set, glistering stones, and of divers colours, and all manner of precious stones, and marble stones in abundance."
        },
        {
          "verse": "3",
          "text": "Moreover, because I have set my affection to the house of my God, I have of mine own proper good, of gold and silver, which I have given to the house of my God, over and above all that I have prepared for the holy house,"
        },
        {
          "verse": "4",
          "text": "Even three thousand talents of gold, of the gold of Ophir, and seven thousand talents of refined silver, to overlay the walls of the houses withal:"
        },
        {
          "verse": "5",
          "text": "The gold for things of gold, and the silver for things of silver, and for all manner of work to be made by the hands of artificers. And who then is willing to consecrate his service this day unto the LORD?"
        },
        {
          "verse": "6",
          "text": "Then the chief of the fathers and princes of the tribes of Israel, and the captains of thousands and of hundreds, with the rulers of the king\u2019s work, offered willingly,"
        },
        {
          "verse": "7",
          "text": "And gave for the service of the house of God of gold five thousand talents and ten thousand drams, and of silver ten thousand talents, and of brass eighteen thousand talents, and one hundred thousand talents of iron."
        },
        {
          "verse": "8",
          "text": "And they with whom precious stones were found gave them to the treasure of the house of the LORD, by the hand of Jehiel the Gershonite."
        },
        {
          "verse": "9",
          "text": "Then the people rejoiced, for that they offered willingly, because with perfect heart they offered willingly to the LORD: and David the king also rejoiced with great joy."
        },
        {
          "verse": "10",
          "text": "Wherefore David blessed the LORD before all the congregation: and David said, Blessed be thou, LORD God of Israel our father, for ever and ever."
        },
        {
          "verse": "11",
          "text": "Thine, O LORD, is the greatness, and the power, and the glory, and the victory, and the majesty: for all that is in the heaven and in the earth is thine; thine is the kingdom, O LORD, and thou art exalted as head above all."
        },
        {
          "verse": "12",
          "text": "Both riches and honour come of thee, and thou reignest over all; and in thine hand is power and might; and in thine hand it is to make great, and to give strength unto all."
        },
        {
          "verse": "13",
          "text": "Now therefore, our God, we thank thee, and praise thy glorious name."
        },
        {
          "verse": "14",
          "text": "But who am I, and what is my people, that we should be able to offer so willingly after this sort? for all things come of thee, and of thine own have we given thee."
        },
        {
          "verse": "15",
          "text": "For we are strangers before thee, and sojourners, as were all our fathers: our days on the earth are as a shadow, and there is none abiding."
        },
        {
          "verse": "16",
          "text": "O LORD our God, all this store that we have prepared to build thee an house for thine holy name cometh of thine hand, and is all thine own."
        },
        {
          "verse": "17",
          "text": "I know also, my God, that thou triest the heart, and hast pleasure in uprightness. As for me, in the uprightness of mine heart I have willingly offered all these things: and now have I seen with joy thy people, which are present here, to offer willingly unto thee."
        },
        {
          "verse": "18",
          "text": "O LORD God of Abraham, Isaac, and of Israel, our fathers, keep this for ever in the imagination of the thoughts of the heart of thy people, and prepare their heart unto thee:"
        },
        {
          "verse": "19",
          "text": "And give unto Solomon my son a perfect heart, to keep thy commandments, thy testimonies, and thy statutes, and to do all these things, and to build the palace, for the which I have made provision."
        },
        {
          "verse": "20",
          "text": "And David said to all the congregation, Now bless the LORD your God. And all the congregation blessed the LORD God of their fathers, and bowed down their heads, and worshipped the LORD, and the king."
        },
        {
          "verse": "21",
          "text": "And they sacrificed sacrifices unto the LORD, and offered burnt offerings unto the LORD, on the morrow after that day, even a thousand bullocks, a thousand rams, and a thousand lambs, with their drink offerings, and sacrifices in abundance for all Israel:"
        },
        {
          "verse": "22",
          "text": "And did eat and drink before the LORD on that day with great gladness. And they made Solomon the son of David king the second time, and anointed him unto the LORD to be the chief governor, and Zadok to be priest."
        },
        {
          "verse": "23",
          "text": "Then Solomon sat on the throne of the LORD as king instead of David his father, and prospered; and all Israel obeyed him."
        },
        {
          "verse": "24",
          "text": "And all the princes, and the mighty men, and all the sons likewise of king David, submitted themselves unto Solomon the king."
        },
        {
          "verse": "25",
          "text": "And the LORD magnified Solomon exceedingly in the sight of all Israel, and bestowed upon him such royal majesty as had not been on any king before him in Israel."
        },
        {
          "verse": "26",
          "text": "Thus David the son of Jesse reigned over all Israel."
        },
        {
          "verse": "27",
          "text": "And the time that he reigned over Israel was forty years; seven years reigned he in Hebron, and thirty and three years reigned he in Jerusalem."
        },
        {
          "verse": "28",
          "text": "And he died in a good old age, full of days, riches, and honour: and Solomon his son reigned in his stead."
        },
        {
          "verse": "29",
          "text": "Now the acts of David the king, first and last, behold, they are written in the book of Samuel the seer, and in the book of Nathan the prophet, and in the book of Gad the seer,"
        },
        {
          "verse": "30",
          "text": "With all his reign and his might, and the times that went over him, and over Israel, and over all the kingdoms of the countries."
        }
      ]
    }
  ]
}
